<template>
  <div id="Products">
    <v-card max-width="100%" outlined>
      <v-row no-gutters class="align-center">
        <v-card-title class="text-h4"> Products </v-card-title>
        <v-spacer />
        <div
          class="d-flex flex-row px-4 flex-wrap align-center"
          style="gap: 24px"
        >
          <span
            v-if="productsContentCheckProgress !== null"
            class="primary--text"
          >
            {{ checkingProductsProgressText }}
          </span>

          <v-btn
            v-if="userGroups?.includes('superadmin')"
            color="secondary"
            class="black--text"
            @click="createGoogleProduct"
            :disabled="
              offline ||
              loadingGoogle ||
              selectedProducts.length === 0 ||
              savingSelectedProducts ||
              bulkEditLoading !== null
            "
            :loading="loadingGoogle"
          >
            Add Google Product
          </v-btn>

          <v-btn
            v-if="userGroups?.includes('superadmin')"
            color="secondary"
            class="black--text"
            @click="createProductSEOs"
            :disabled="
              offline ||
              loadingSEOs ||
              savingSelectedProducts ||
              bulkEditLoading !== null
            "
            :loading="loadingSEOs"
          >
            Create Product SEOs
          </v-btn>

          <v-btn
            color="secondary"
            class="black--text"
            @click="checkIfProductContentExists"
            :loading="loadingCheck"
            :disabled="
              offline ||
              loadingCheck ||
              savingSelectedProducts ||
              bulkEditLoading !== null
            "
          >
            Check Content
          </v-btn>
          <!-- <v-btn
            color="warning"
            class="black--text"
            @click="migrateProductSkusToString"
            :disabled="offline || loading"
          >
            Migrate SKUs
          </v-btn> -->
          <!-- <v-btn
            color="secondary"
            class="black--text"
            @click="adminAppsyncUpdateProducts"
            :disabled="offline || savingSelectedProducts"
          >
            Update Products
          </v-btn> -->
          <v-btn
            color="secondary"
            class="black--text"
            @click="manageProductCategories"
            :disabled="
              offline || savingSelectedProducts || bulkEditLoading !== null
            "
          >
            Manage Categories
          </v-btn>
          <v-btn
            color="secondary"
            class="black--text"
            @click="manageProductTags"
            :disabled="
              offline || savingSelectedProducts || bulkEditLoading !== null
            "
          >
            Manage Tags
          </v-btn>
          <v-btn
            color="primary"
            class=""
            @click="createItem"
            :disabled="
              offline || savingSelectedProducts || bulkEditLoading !== null
            "
          >
            New Product
          </v-btn>
          <v-btn
            color="primary"
            class=""
            @click="createBundle"
            :disabled="
              offline ||
              savingSelectedProducts ||
              selectedProducts.length === 0 ||
              bulkEditLoading !== null
            "
          >
            New Bundle
          </v-btn>
        </div>
      </v-row>

      <v-row class="px-4">
        <v-col cols="12" sm="4" md="3">
          <v-text-field
            v-model="productsDataTableSearch"
            append-icon="mdi-magnify"
            label="Search"
            @input="changeProductsSearchQuery"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <v-combobox
            class="productsSearchInputCSS pt-2"
            v-model="productsSearchTags"
            label="Tags"
            multiple
            chips
            dense
            @change="changeProductsSearchQuery"
            min-height="36px"
            deletable-chips
            clearable
            :items="syncedProductTagArray"
            item-text="name"
            :return-object="false"
            item-value="id"
          ></v-combobox>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <v-menu
            v-model="searchProductCategoriesMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            :nudge-bottom="-12"
            :rounded="false"
          >
            <template v-slot:activator="{ on }">
              <div @click="toggleMenu">
                <v-combobox
                  class="productsSearchInputCSS pt-2"
                  :value="computedProductsSearchCategories"
                  label="Categories"
                  multiple
                  chips
                  dense
                  min-height="36px"
                  clearable
                  v-on="on"
                  readonly
                  @click:clear="productsDataTableSearchCategories = []"
                ></v-combobox>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <v-treeview
                  :items="categoryTree"
                  color="primary"
                  selected-color="primary"
                  selectable
                  item-key="id"
                  open-on-click
                  selection-type="independent"
                  v-model="productsDataTableSearchCategories"
                  @input="changeProductsSearchQuery"
                ></v-treeview>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-col>

        <v-col cols="6" sm="4" md="3">
          <v-autocomplete
            class="productsSearchInputCSS pt-2"
            v-model="productsDataTableSearchSubjects"
            label="Subjects"
            :items="subjectFilterItems"
            :item-text="subjectLabel"
            item-value="id"
            :filter="subjectMatchesSearch"
            :loading="loadingSubjects"
            multiple
            chips
            dense
            min-height="36px"
            deletable-chips
            clearable
            @change="changeProductsSearchQuery"
          ></v-autocomplete>
        </v-col>

        <v-col cols="4" sm="3" md="2">
          <v-checkbox
            v-model="searchPhysicalProduct"
            label="Physical Product"
            @change="changePhysEcommSubSearch('physical')"
            class="mt-0"
          ></v-checkbox
        ></v-col>
        <v-col cols="4" sm="3" md="2">
          <v-checkbox
            v-model="searchSubscriptionProduct"
            label="Subscription Product"
            @change="changePhysEcommSubSearch('sub')"
            class="mt-0"
          ></v-checkbox
        ></v-col>
        <v-col cols="4" sm="3" md="2">
          <v-checkbox
            v-model="searchECommerceProduct"
            label="E-Commerce Product"
            @change="changePhysEcommSubSearch('ecomm')"
            class="mt-0"
          ></v-checkbox></v-col
        ><v-col cols="4" sm="3" md="2">
          <v-checkbox
            v-model="showOnlySoftDeleted"
            label="Show Only Soft Deleted"
            @change="changeProductsSearchQuery"
            dense
          ></v-checkbox>
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-checkbox
            v-model="bulkEditAll"
            label="Bulk Edit All"
            class="mt-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="6" sm="4" md="3" v-if="failedProductsContent.length > 0">
          <v-checkbox
            v-model="searchMissingProductContent"
            @change="queryProducts"
            label="Missing Content"
            class="mt-0"
          ></v-checkbox
        ></v-col>
      </v-row>

      <div v-if="selectedProducts.length > 0 || bulkEditAll">
        <v-card-title class="text-h5 pb-4 pt-0"> Bulk Edit </v-card-title>

        <div class="px-3 pb-3" style="max-width: 470px">
          <!-- <v-col class="pt-0" cols="12" sm="6" md="4"> -->
          <v-expansion-panels
            class="mb-3"
            style="justify-content: left"
            v-model="expBulkEditPanels"
          >
            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1"> mdi-star </v-icon>
                  <div>
                    <span> Feature</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row class="pa-3 d-flex" style="gap: 12px">
                  <v-btn
                    color="primary"
                    @click="featureProducts"
                    :disabled="
                      offline ||
                      savingSelectedProducts ||
                      (bulkEditLoading !== null &&
                        bulkEditLoading !== 'feature')
                    "
                    :loading="bulkEditLoading === 'feature'"
                  >
                    <v-icon left> mdi-star </v-icon>Feature Products
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="unFeatureProducts"
                    :disabled="
                      offline ||
                      savingSelectedProducts ||
                      (bulkEditLoading !== null &&
                        bulkEditLoading !== 'unfeature')
                    "
                    :loading="bulkEditLoading === 'unfeature'"
                  >
                    <v-icon left> mdi-star-outline </v-icon>Unfeature Products
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1">mdi-calendar</v-icon>
                  <div>
                    <span> Schedule</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row class="pa-3 d-flex align-center" style="gap: 12px">
                  <v-dialog
                    v-model="bulkEditDateTimeDialog"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedBulkEditPublishDate"
                        readonly
                        label="Publish Date"
                        v-bind="{ ...attrs, ...$attrs }"
                        v-on="on"
                        clearable
                        :rules="formRules.publishDate"
                        required
                        @click:clear="updateBulkEditPublishDateTime('clear')"
                      ></v-text-field>
                    </template>
                    <v-card class="t-datetime-picker white">
                      <v-toolbar height="36" color="primary" dark flat>
                        <v-tabs v-model="bulkEditDateTimeTab" grow height="36">
                          <v-tabs-slider color="white"></v-tabs-slider>
                          <v-tab href="#date">
                            <v-icon>mdi-calendar</v-icon>
                          </v-tab>
                          <v-tab href="#time">
                            <v-icon>mdi-clock</v-icon>
                          </v-tab>
                          <v-btn
                            depressed
                            text
                            class="rounded-0"
                            @click="closeBulkEditDateTimeDialog"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </v-tabs>
                      </v-toolbar>

                      <v-tabs-items v-model="bulkEditDateTimeTab">
                        <v-tab-item value="date">
                          <v-date-picker
                            v-model="bulkEditPublishDate"
                            @change="updateBulkEditPublishDateTime"
                            class="rounded-0"
                            @input="bulkEditDateTimeTab = 'time'"
                            full-width
                          >
                          </v-date-picker>
                        </v-tab-item>
                        <v-tab-item value="time">
                          <v-time-picker
                            :key="bulkEditDateTimeTab"
                            v-model="bulkEditPublishTime"
                            format="24hr"
                            class="rounded-0"
                            full-width
                            @change="updateBulkEditPublishDateTime"
                          >
                          </v-time-picker>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    color="primary"
                    @click="scheduleProducts"
                    :disabled="
                      offline ||
                      savingSelectedProducts ||
                      !bulkEditPublishDateTime ||
                      (bulkEditLoading !== null &&
                        bulkEditLoading !== 'schedule')
                    "
                    :loading="bulkEditLoading === 'schedule'"
                  >
                    Schedule
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="unScheduleProducts"
                    :disabled="
                      offline ||
                      savingSelectedProducts ||
                      (bulkEditLoading !== null &&
                        bulkEditLoading !== 'unschedule')
                    "
                    :loading="bulkEditLoading === 'unschedule'"
                  >
                    Un-Publish
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1">mdi-currency-usd</v-icon>
                  <div>
                    <span> Change Price</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row
                  class="pa-3 d-flex align-center justify-end"
                  style="gap: 12px"
                >
                  <v-text-field
                    v-model="bulkEditPriceChangeValue"
                    label="Price Change Value"
                    type="number"
                    prepend-icon="mdi-alpha-r"
                    @input="bulkEditPriceChangePercent = null"
                  ></v-text-field>

                  <v-text-field
                    v-model="bulkEditPriceChangePercent"
                    label="Price Change Percentage"
                    type="number"
                    append-icon="mdi-percent"
                    @input="bulkEditPriceChangeValue = null"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    @click="changeProductsPrice('increase')"
                    :disabled="
                      offline ||
                      savingSelectedProducts ||
                      ((!bulkEditPriceChangePercent ||
                        bulkEditPriceChangePercent === '') &&
                        (!bulkEditPriceChangeValue ||
                          bulkEditPriceChangeValue === '')) ||
                      (bulkEditLoading !== null &&
                        bulkEditLoading !== 'increase_price')
                    "
                    :loading="bulkEditLoading === 'increase_price'"
                  >
                    Increase
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="changeProductsPrice('decrease')"
                    :disabled="
                      offline ||
                      savingSelectedProducts ||
                      ((!bulkEditPriceChangePercent ||
                        bulkEditPriceChangePercent === '') &&
                        (!bulkEditPriceChangeValue ||
                          bulkEditPriceChangeValue === '')) ||
                      (bulkEditLoading !== null &&
                        bulkEditLoading !== 'decrease_price')
                    "
                    :loading="bulkEditLoading === 'decrease_price'"
                  >
                    Decrease
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1">mdi-sale</v-icon>
                  <div>
                    <span>Discount</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row
                  class="pa-3 d-flex align-center justify-end"
                  style="gap: 12px"
                >
                  <v-text-field
                    v-model="bulkEditDiscountPercent"
                    label="Discount Percentage"
                    type="number"
                    append-icon="mdi-percent"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    @click="discountProducts"
                    :disabled="
                      offline ||
                      savingSelectedProducts ||
                      !bulkEditDiscountPercent ||
                      bulkEditDiscountPercent === '' ||
                      (bulkEditLoading !== null &&
                        bulkEditLoading !== 'discount')
                    "
                    :loading="bulkEditLoading === 'discount'"
                  >
                    Discount
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="pa-2">
                <div class="d-flex align-center">
                  <v-icon class="mr-1">mdi-swap-horizontal</v-icon>
                  <div>
                    <span>Type</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                id="expPanelContent"
                color="grey lighten-3"
              >
                <v-row class="pa-3 d-flex align-center" style="gap: 12px">
                  <v-checkbox
                    v-model="bulkEditPhysicalProduct"
                    label="Physical Product"
                    @change="changeBulkPhysEcommSub('physical')"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="bulkEditSubscriptionProduct"
                    label="Subscription Product"
                    @change="changeBulkPhysEcommSub('sub')"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="bulkEditECommerceProduct"
                    label="E-Commerce Product"
                    @change="changeBulkPhysEcommSub('ecomm')"
                  >
                  </v-checkbox>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    @click="changeProductsType"
                    :disabled="
                      offline ||
                      savingSelectedProducts ||
                      (!bulkEditPhysicalProduct &&
                        !bulkEditSubscriptionProduct &&
                        !bulkEditECommerceProduct) ||
                      (bulkEditLoading !== null &&
                        bulkEditLoading !== 'change_type')
                    "
                    :loading="bulkEditLoading === 'change_type'"
                  >
                    Change Type
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>

      <!-- {{ ("SYNCED PRODUCTS: ", syncedProducts) }} -->

      <div class="px-4">
        <v-data-table
          :footer-props="{
            showFirstLastPage: true,
          }"
          id="productsDataTable"
          :headers="headers"
          :items="products"
          :sort-desc.sync="sortDesc"
          :sort-by.sync="sortBy"
          :items-per-page.sync="productsDataTableRowsPerPage"
          @update:items-per-page="queryProducts"
          :page.sync="productsDataTablePageCount"
          @update:page="productsDataTablePageCountUpdate"
          :server-items-length="productsDataTableServerItemsLength"
          must-sort
          :loading="
            !syncedProductCategories ||
            (!syncedProducts && products?.length === 0)
          "
          loading-text="Loading Products..."
          no-data-text="No Products found"
          :show-select="!bulkEditAll"
          v-model="selectedProducts"
        >
          <template v-slot:[`item.featured`]="{ item }">
            <v-icon v-if="item.featured">mdi-star</v-icon>
            <v-icon v-else>mdi-star-outline</v-icon>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            {{ formatPrice(item.price) }}
          </template>
          <template v-slot:[`item.discountPercentage`]="{ item }">
            {{ formatPercentage(item.discountPercentage) }}
          </template>
          <template v-slot:[`item.categoryId`]="{ item }">
            {{ formatCategoryId(item.categoryId) }}
          </template>
          <template v-slot:[`item.subjectID`]="{ item }">
            {{
              item.subjectID
                ? subjectLabel(subjectsByID[item.subjectID])
                : "—"
            }}
          </template>
          <template v-slot:[`item.publishDate`]="{ item }">
            {{ formatDateTime(item.publishDate) }}
          </template>
          <template v-slot:[`item.updatedAt`]="{ item }">
            {{ formatDateTime(item.updatedAt) }}
          </template>
          <template v-slot:[`item.physical`]="{ item }">
            <v-icon v-if="item.physical">mdi-check</v-icon>
          </template>
          <template v-slot:[`item.eCommerceProduct`]="{ item }">
            <v-icon v-if="item.eCommerceProduct">mdi-check</v-icon>
          </template>
          <template v-slot:[`item.subscriptionProduct`]="{ item }">
            <v-icon v-if="item.subscriptionProduct">mdi-check</v-icon>
          </template>

          <template v-slot:[`item.missingFiles`]="{ item }">
            {{ getMissingFilesCount(item.id) }}
          </template>

          <template v-slot:[`item.files`]="{ item }">
            {{ getProductFileCount(item.id) }}
          </template>
          <template v-slot:[`item.urls`]="{ item }">
            {{ getProductURLCount(item.id) }}
          </template>

          <template v-slot:[`item.softDeleted`]="{ item }">
            <v-chip
              v-if="item.softDeleted"
              small
              color="error"
              text-color="white"
            >
              <v-icon x-small left>mdi-trash-can</v-icon>
              Deleted
            </v-chip>
            <span v-else class="text--secondary">—</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="shareProduct(item)">
              mdi-share
            </v-icon>
            <v-icon
              small
              class="mr-2"
              :disabled="offline || loading || savingSelectedProducts"
              @click="duplicateItem(item)"
            >
              mdi-content-copy
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="offline || loading || savingSelectedProducts"
            >
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="copyProductID(item)">
              mdi-identifier
            </v-icon>
            <v-icon
              small
              class="ml-2"
              color="error"
              :disabled="offline || loading || savingSelectedProducts"
              @click="toggleSoftDeleteProduct(item)"
              :title="
                item.softDeleted ? 'Restore Product' : 'Soft Delete Product'
              "
            >
              {{ item.softDeleted ? "mdi-delete-restore" : "mdi-trash-can" }}
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog persistent v-if="dialog" v-model="dialog" max-width="800px">
      <v-card>
        <v-form ref="form" v-model="valid" @submit.prevent="save">
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.title"
                    label="Title"
                    :rules="formRules.title"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-text-field
                    v-model="editedItem.sku"
                    label="SKU"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-checkbox
                    v-model="editedItem.featured"
                    label="Featured"
                  ></v-checkbox
                ></v-col>
                <v-col cols="6" sm="3">
                  <v-checkbox
                    v-model="editedItem.physical"
                    label="Physical Product"
                    @change="changePhysEcommSub('physical')"
                  ></v-checkbox
                ></v-col>
                <v-col cols="6" sm="3">
                  <v-text-field
                    v-model="editedItem.price"
                    label="Price"
                    type="number"
                    prefix="R"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-text-field
                    v-model="editedItem.discountPercentage"
                    label="Discount"
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-text-field
                    :value="productVat"
                    label="Vat (15%)"
                    type="number"
                    prefix="R"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-dialog v-model="datetimeDialog" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedProductPublishDate"
                        readonly
                        label="Publish Date"
                        v-bind="{ ...attrs, ...$attrs }"
                        v-on="on"
                        clearable
                        :rules="formRules.publishDate"
                        required
                        @click:clear="updateProductPublishDateTime('clear')"
                      ></v-text-field>
                    </template>
                    <v-card class="t-datetime-picker white">
                      <v-toolbar height="36" color="primary" dark flat>
                        <v-tabs v-model="dateTimeTab" grow height="36">
                          <v-tabs-slider color="white"></v-tabs-slider>
                          <v-tab href="#date">
                            <v-icon>mdi-calendar</v-icon>
                          </v-tab>
                          <v-tab href="#time">
                            <v-icon>mdi-clock</v-icon>
                          </v-tab>
                          <v-btn
                            depressed
                            text
                            class="rounded-0"
                            @click="closeDateTimeDialog"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </v-tabs>
                      </v-toolbar>

                      <v-tabs-items v-model="dateTimeTab">
                        <v-tab-item value="date">
                          <v-date-picker
                            v-model="productPublishDate"
                            @change="updateProductPublishDateTime"
                            class="rounded-0"
                            @input="dateTimeTab = 'time'"
                            full-width
                          >
                          </v-date-picker>
                        </v-tab-item>
                        <v-tab-item value="time">
                          <v-time-picker
                            :key="dateTimeTab"
                            v-model="productPublishTime"
                            format="24hr"
                            class="rounded-0"
                            full-width
                            @change="updateProductPublishDateTime"
                          >
                          </v-time-picker>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-dialog>
                </v-col>
                <v-col cols="6" sm="3">
                  <v-checkbox
                    v-model="editedItem.subscriptionProduct"
                    label="Subscription Product"
                    @change="changePhysEcommSub('sub')"
                  ></v-checkbox
                ></v-col>
                <v-col cols="6" sm="3">
                  <v-checkbox
                    v-model="editedItem.eCommerceProduct"
                    label="E-Commerce Product"
                    @change="changePhysEcommSub('ecomm')"
                  ></v-checkbox
                ></v-col>
                <v-col cols="12">
                  <v-combobox
                    v-model="editedItemComputedTags"
                    label="Tags"
                    multiple
                    chips
                    append-icon=""
                    :items="productTagNameArray"
                    deletable-chips
                    clearable
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6">
                  <!-- <v-combobox
                    v-model="editedItemComputedCategory"
                    label="Category"
                    append-icon=""
                    :items="computedProductCategoryArray"
                    clearable
                  ></v-combobox> -->

                  <v-menu
                    v-model="editProductCategoriesMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    :nudge-bottom="-12"
                    :rounded="false"
                  >
                    <template v-slot:activator="{ on }">
                      <div @click="toggleEditProductMenu">
                        <v-combobox
                          class="pt-2"
                          :value="computedEditProductsCategoriesValue"
                          label="Categories"
                          :rules="formRules.category"
                          required
                          clearable
                          v-on="on"
                          readonly
                          @click:clear="editedItem.categoryId = ''"
                        ></v-combobox>
                      </div>
                    </template>
                    <v-card max-height="200px" class="overflow-y-auto">
                      <v-card-text>
                        <v-treeview
                          :items="categoryTree"
                          color="primary"
                          activatable
                          item-key="id"
                          @update:active="updateProductCategory"
                          :active="[editedItem.categoryId]"
                        ></v-treeview>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="editedItem.subjectID"
                    class="pt-2"
                    :items="sortedSubjects"
                    :item-text="subjectLabel"
                    item-value="id"
                    :filter="subjectMatchesSearch"
                    :loading="loadingSubjects"
                    label="Subject"
                    hint='Search with any words, e.g. "4 maths"'
                    persistent-hint
                    clearable
                  ></v-autocomplete>
                </v-col>
                
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="editedItem.videoPreview"
                    label="Video Preview"
                    hint='Eg. Vimeo: "1031522389", YouTube: "c_GorHGJ9Qg"'
                    :rules="formRules.validateVideoId"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <span class="text-h6">Description</span>
                  <RichTextEditor
                    v-model="editedItem.description"
                    :datamodelId="editedItem.id"
                    s3Folder="Products"
                  >
                  </RichTextEditor>
                </v-col>
                <v-col cols="12">
                  <v-card class="px-3 pt-3">
                    <v-row
                      no-gutters
                      justify="space-between"
                      style="gap: 12px"
                      class="pb-3"
                    >
                      <span class="text-h6">Product Images</span>
                      <v-btn
                        color="primary"
                        @click="uploadThumbnailImage"
                        :disabled="offline || editedIndex === -1 || loading"
                      >
                        {{
                          editedIndex === -1
                            ? "Save product to add images"
                            : "Add Image"
                        }}
                      </v-btn>
                    </v-row>
                    <v-row
                      v-if="thumbnailImagesSrc?.length > 0"
                      no-gutters
                      class="thumbnailvrow"
                      style="margin-top: -12px"
                    >
                      <draggable
                        v-model="editedItem.thumbnails"
                        style="width: 100%"
                        class="d-flex flex-wrap"
                      >
                        <v-col
                          v-for="(
                            thumbnailKey, thumbnailIndex
                          ) in editedItem.thumbnails"
                          :key="thumbnailIndex"
                          cols="12"
                          sm="6"
                          md="4"
                          class="pa-3"
                        >
                          <div
                            @mouseenter="mouseOver(thumbnailIndex)"
                            @mouseleave="mouseOut"
                            class="d-flex justify-center align-center"
                            style="
                              position: relative;
                              border: thin solid;
                              border-radius: 4px;
                              height: 100%;
                              width: 100%;
                            "
                            :style="
                              productImgHoveringIndex === thumbnailIndex
                                ? 'border-color: #ffa9b8;'
                                : ''
                            "
                          >
                            <v-img
                              max-height="100%"
                              max-width="100%"
                              :src="getThumbnailImageSrc(thumbnailKey)"
                              cover
                              style="border-radius: 4px"
                            ></v-img>
                            <!-- <img
                              style="
                                max-width: 100%;
                                max-height: 100%;
                                object-fit: cover;
                                border-radius: 8px;
                              "
                              :src="getThumbnailImageSrc(thumbnailKey)"
                            /> -->

                            <div
                              v-if="
                                productImgHoveringIndex === thumbnailIndex &&
                                editedIndex !== -1
                              "
                              style="position: absolute; top: 0; right: 0"
                            >
                              <v-menu offset-x v-model="isProductImgMenuOpen">
                                <template
                                  v-slot:activator="{ on: menu, attrs }"
                                >
                                  <v-btn v-bind="attrs" icon v-on="{ ...menu }">
                                    <v-icon>mdi-cog</v-icon>
                                  </v-btn>
                                </template>
                                <div
                                  class="d-flex flex-column"
                                  style="background-color: white"
                                  @mouseleave="mouseOutMenu"
                                >
                                  <v-btn
                                    text
                                    color="red"
                                    @click="
                                      deleteProductThumbnail(thumbnailKey)
                                    "
                                  >
                                    Remove
                                  </v-btn>
                                </div>
                              </v-menu>
                            </div>
                          </div>
                        </v-col>
                      </draggable>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card class="px-3 pt-3">
                    <v-row
                      no-gutters
                      justify="space-between"
                      style="gap: 12px"
                      class="pb-3"
                    >
                      <span class="text-h6">Product Content</span>

                      <div
                        class="d-flex flex-row align-center"
                        style="gap: 12px"
                      >
                        <span
                          v-if="uploadingFiles?.length > 0"
                          class="primary--text"
                        >
                          {{ uploadingFilesText }}
                        </span>

                        <v-btn
                          color="primary"
                          @click="uploadProductContent"
                          :disabled="offline || loading || editedIndex === -1"
                        >
                          {{
                            editedIndex === -1
                              ? "Save product to add files"
                              : "Add Files"
                          }}
                        </v-btn>
                      </div>
                    </v-row>
                    <v-row
                      v-if="editedIndex > -1"
                      class="thumbnailvrow"
                      style="margin-top: -12px"
                    >
                      <v-col
                        cols="12"
                        v-if="productContentFileKeys?.length > 0"
                      >
                        <v-combobox
                          v-model="productContentFileKeys"
                          multiple
                          chips
                          label="Files"
                          appendIcon=""
                          deletable-chips
                          @change="changeEditedItemProductContent"
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip
                              class="text-wrap py-1"
                              :color="isFileKeyMissing(item) ? 'red' : ''"
                              :dark="isFileKeyMissing(item)"
                              style="height: fit-content"
                              close
                              @click:close="removeProductContentFileKey(index)"
                              :disabled="offline || loading"
                              close-icon="mdi-delete"
                              >{{
                                (isFileKeyMissing(item) ? "(MISSING) " : "") +
                                item
                              }}</v-chip
                            >
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12">
                        <v-combobox
                          v-model="productContentUrls"
                          label="Videos"
                          hint='Eg. Vimeo: "1031522389", YouTube: "c_GorHGJ9Qg"'
                          multiple
                          chips
                          appendIcon=""
                          :rules="formRules.validateVideoId"
                          deletable-chips
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12">
                  <v-card class="px-3 pt-3">
                    <v-row
                      no-gutters
                      justify="space-between"
                      style="gap: 12px"
                      class="pb-3"
                    >
                      <span class="text-h6">Questions</span>
                      <v-btn
                        color="primary"
                        @click="addQuestion"
                        :disabled="offline || loading"
                      >
                        Add Question
                      </v-btn>
                    </v-row>
                    <v-row
                      v-if="editedItem.questions?.length > 0"
                      no-gutters
                      class="plannerPanelTopBorder"
                    >
                      <v-expansion-panels
                        class="mb-3"
                        style="justify-content: left"
                        v-model="expQuestionPanels"
                      >
                        <draggable
                          v-model="editedItem.questions"
                          style="width: 100%"
                        >
                          <v-expansion-panel
                            v-for="(question, index) in editedItem.questions"
                            :key="index"
                          >
                            <v-expansion-panel-header class="pa-2">
                              <div class="d-flex align-center">
                                <v-icon class="mr-1">
                                  mdi-drag-vertical
                                </v-icon>
                                <div style="text-wrap: nowrap">
                                  <span
                                    >Question{{
                                      question.label && question.label !== ""
                                        ? ":&nbsp;"
                                        : ""
                                    }}</span
                                  >
                                </div>
                                <div>
                                  <span>
                                    {{
                                      question.label && question.label !== ""
                                        ? question.label
                                        : ""
                                    }}</span
                                  >
                                </div>
                              </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content
                              id="expPanelContent"
                              color="grey lighten-3"
                            >
                              <v-row class="pt-3">
                                <v-col cols="12" sm="6" md="4" class="py-0">
                                  <v-text-field
                                    v-model="question.label"
                                    label="Label"
                                    :rules="formRules.label"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" class="py-0">
                                  <v-select
                                    v-model="question.type"
                                    label="Type"
                                    :rules="formRules.type"
                                    required
                                    :items="formFieldTypes"
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" class="py-0">
                                  <v-text-field
                                    v-model="question.placeholder"
                                    label="Placeholder"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" class="py-0">
                                  <v-text-field
                                    v-model="question.hint"
                                    label="Hint"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" class="py-0">
                                  <v-checkbox
                                    v-model="question.required"
                                    label="Required"
                                  ></v-checkbox>
                                </v-col>
                                <v-col
                                  v-if="
                                    question.type === 'Select' ||
                                    question.type === 'Multi Select' ||
                                    question.type === 'Radio' ||
                                    question.type === 'Checkbox'
                                  "
                                  cols="12"
                                  class="py-0"
                                >
                                  <v-combobox
                                    v-model="question.items"
                                    :label="
                                      question.type === 'Select' ||
                                      question.type === 'Multi Select'
                                        ? 'Select Values'
                                        : question.type === 'Radio'
                                        ? 'Radio Values'
                                        : question.type === 'Checkbox'
                                        ? 'Checkbox Values'
                                        : ''
                                    "
                                    :error-messages="
                                      comboboxErrors(
                                        question.items,
                                        question.type,
                                      )
                                    "
                                    required
                                    multiple
                                    chips
                                    deletable-chips
                                    clearable
                                    lazy-validation
                                  ></v-combobox>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-spacer />
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      color="red"
                                      fab
                                      small
                                      icon
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="removeQuestion(index)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Delete Field</span>
                                </v-tooltip>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </draggable>
                      </v-expansion-panels>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12">
                  <v-card class="px-3 pt-3">
                    <v-row
                      no-gutters
                      justify="space-between"
                      style="gap: 12px"
                      class="pb-3"
                    >
                      <span class="text-h6">Product Addons</span>
                      <div
                        class="d-flex flex-row align-center"
                        style="gap: 12px"
                      >
                        <span
                          v-if="uploadingFiles?.length > 0"
                          class="primary--text"
                        >
                          {{ uploadingFilesText }}
                        </span>
                        <v-btn
                          color="primary"
                          @click="createAddon"
                          :disabled="offline || loading || editedIndex === -1"
                        >
                          {{
                            editedIndex === -1
                              ? "Save product to add addons"
                              : "New Addon"
                          }}
                        </v-btn>
                      </div>
                    </v-row>
                    <v-row v-if="editedAddons.length > 0" no-gutters>
                      <div style="width: 100%">
                        <v-data-table
                          :headers="addonHeaders"
                          :items="editedAddons"
                          no-data-text="No Addons"
                        >
                          <template v-slot:[`item.price`]="{ item }">
                            {{ formatPrice(item.price) }}
                          </template>
                          <template v-slot:[`item.fileKey`]="{ item }">
                            {{
                              item.fileKey
                                ? getFileNameFromKey(item.fileKey)
                                : ""
                            }}
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              small
                              class="mr-2"
                              @click="editAddon(item)"
                              :disabled="offline || loading"
                            >
                              mdi-pencil
                            </v-icon>
                            <v-icon
                              small
                              @click="deleteAddon(item)"
                              :disabled="offline || loading"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </div>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12">
                  <v-card class="px-3 pt-3">
                    <v-row
                      no-gutters
                      justify="space-between"
                      style="gap: 12px"
                      class="pb-3"
                    >
                      <span class="text-h6">Product Recommendations</span>
                      <v-btn
                        color="primary"
                        @click="createRecommendation"
                        :disabled="offline || loading || editedIndex === -1"
                      >
                        {{
                          editedIndex === -1
                            ? "Save product to add recommendations"
                            : "New Recommendation"
                        }}
                      </v-btn>
                    </v-row>
                    <v-row v-if="editedRecommendations.length > 0" no-gutters>
                      <div style="width: 100%">
                        <v-data-table
                          :headers="recommendationHeaders"
                          :items="editedRecommendations"
                          no-data-text="No Recommendations"
                        >
                          <template v-slot:[`item.title`]="{ item }">
                            {{ getProductTitleById(item.productId) }}
                          </template>
                          <template
                            v-slot:[`item.discountPercentage`]="{ item }"
                          >
                            {{ formatPercentage(item.discountPercentage || 0) }}
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              small
                              class="mr-2"
                              @click="editRecommendation(item)"
                              :disabled="offline || loading"
                            >
                              mdi-pencil
                            </v-icon>
                            <v-icon
                              small
                              @click="deleteRecommendation(item)"
                              :disabled="offline || loading"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </div>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              :disabled="editedIndex === -1 || productSaved"
              @click="cancelWarning"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="close" :disabled="loading">
              Close
            </v-btn>
            <v-btn
              :disabled="
                !syncedProductCategories ||
                !valid ||
                productSaved ||
                offline ||
                loading
              "
              :loading="loading || !syncedProductCategories"
              color="primary"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialogCancel" max-width="500px">
      <v-card>
        <v-card-title class="justify-center" style="word-break: break-word"
          >Are you sure you want to discard the changes made to this
          product?</v-card-title
        >
        <v-card-actions>
          <v-btn
            color="secondary"
            class="black--text"
            :disabled="cancelingChanges"
            @click="closeCancel"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="cancelingChanges" @click="cancel"
            >YES</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="justify-center"
          >Are you sure you want to delete this product?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="deletingItem" @click="closeDelete"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="deletingItem"
            :disabled="deletingItem"
            @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialogProductContentDelete" max-width="500px">
      <v-card>
        <v-card-title class="justify-center"
          >Are you sure you want to delete this content?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="loading"
            @click="closeProductContentDelete"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="loading"
            :loading="loading"
            @click="deleteProductContent"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogManageProductTags" max-width="800px">
      <v-card>
        <v-row no-gutters class="align-center">
          <v-card-title class="text-h5"> Manage Tags </v-card-title>
          <v-spacer />
          <v-btn
            color="primary"
            class="mx-4"
            @click="createProductTag"
            :disabled="offline"
          >
            New Tag
          </v-btn>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" sm="6" class="px-4">
            <v-text-field
              v-model="tagsSearch"
              append-icon="mdi-magnify"
              label="Search"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :footer-props="{
                    showFirstLastPage: true,
                  }"
                  id="tagsDataTable"
                  :headers="tagHeaders"
                  :items="syncedProductTagArray"
                  :sort-desc.sync="tagSortDesc"
                  :sort-by.sync="tagSortBy"
                  must-sort
                  loading-text="Loading Tags..."
                  no-data-text="No Tags found"
                  :search="tagsSearch"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editProductTag(item)"
                      :disabled="offline"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="deleteProductTag(item)"
                      :disabled="offline"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeManageProductTags">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogEditProductTag" max-width="500px">
      <v-card>
        <v-form ref="form" v-model="valid" @submit.prevent="saveProductTag">
          <v-card-title>
            <span class="text-h5">{{ tagFormTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedProductTagItem.name"
                    label="Tag Name"
                    :rules="formRules.tagName"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="secondary"
              class="black--text"
              @click="closeEditProductTag"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveProductTag">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogDeleteProductTag" max-width="500px">
      <v-card>
        <v-card-title class="justify-center"
          >Are you sure you want to delete this tag?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="deletingItem"
            @click="closeDeleteProductTag"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="deletingItem"
            :disabled="deletingItem"
            @click="deleteProductTagConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogManageProductCategories"
      max-width="800px"
    >
      <v-card>
        <v-row no-gutters class="align-center">
          <v-card-title class="text-h5"> Manage Categories </v-card-title>
          <v-spacer />
          <v-btn
            color="primary"
            class="mx-4"
            @click="createProductCategory"
            :disabled="offline"
          >
            New Category
          </v-btn>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" sm="6" class="px-4">
            <v-text-field
              v-model="categoriesSearch"
              append-icon="mdi-magnify"
              label="Search"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :footer-props="{
                    showFirstLastPage: true,
                  }"
                  id="categoriesDataTable"
                  :headers="categoryHeaders"
                  :items="syncedProductCategoryArray"
                  :sort-desc.sync="categorySortDesc"
                  :sort-by.sync="categorySortBy"
                  must-sort
                  loading-text="Loading Categories..."
                  no-data-text="No Categories found"
                  :search="categoriesSearch"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editProductCategory(item)"
                      :disabled="offline"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="deleteProductCategory(item)"
                      :disabled="offline"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeManageProductCategories"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-if="dialogEditProductCategory"
      v-model="dialogEditProductCategory"
      max-width="500px"
    >
      <v-card>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="saveProductCategory"
        >
          <v-card-title>
            <span class="text-h5">{{ categoryFormTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedProductCategoryItem.name"
                    label="Category Name"
                    :rules="formRules.categoryName"
                    required
                    @input="generateSlug"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedProductCategoryItem.slug"
                    label="Category Slug"
                    readonly
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="editedProductCategoryItem.grade"
                    :items="gradeArray"
                    label="Grade"
                    clearable
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <!-- <v-combobox
                    v-model="editedProductCategoryItemComputedParent"
                    label="Parent Category"
                    append-icon=""
                    :items="computedProductCategoryParentArray"
                    clearable
                  ></v-combobox> -->

                  <v-menu
                    v-model="editCategoryParentMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    :nudge-bottom="-12"
                    :rounded="false"
                  >
                    <template v-slot:activator="{ on }">
                      <div @click="toggleEditCategoryParentMenu">
                        <v-combobox
                          class="productsSearchInputCSS pt-2"
                          :value="computedEditCategoryParentValue"
                          label="Parent Category"
                          dense
                          min-height="36px"
                          clearable
                          v-on="on"
                          readonly
                          @click:clear="editedProductCategoryItem.parentId = ''"
                        ></v-combobox>
                      </div>
                    </template>
                    <v-card max-height="200px" class="overflow-y-auto">
                      <v-card-text>
                        <v-treeview
                          :items="categoryParentTree"
                          color="primary"
                          activatable
                          item-key="id"
                          @update:active="updateCategoryParent"
                          :active="[editedProductCategoryItem.parentId]"
                        ></v-treeview>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="secondary"
              class="black--text"
              @click="closeEditProductCategory"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="
                !syncedProductCategories || !valid || offline || loading
              "
              :loading="loading || !syncedProductCategories"
              @click="saveProductCategory"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogDeleteProductCategory"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center"
          >Are you sure you want to delete this category?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="deletingItem"
            @click="closeDeleteProductCategory"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="deletingItem"
            :disabled="deletingItem"
            @click="deleteProductCategoryConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogProductContentVerify" max-width="fit-content">
      <v-card width="fit-content">
        <v-card-title
          v-if="failedProductsContent.length === 0"
          class="justify-center"
          >All files exist
          <v-icon color="success" class="slide-x-transition">
            mdi-check-circle
          </v-icon></v-card-title
        >
        <div v-else>
          <v-card-title class="justify-center"
            >The following products are missing files</v-card-title
          >

          <ul class="mx-3">
            <li
              v-for="(product, index) in failedProductsContent"
              :key="'product-' + index"
            >
              <v-card-text class="pa-0">{{ product.title }}</v-card-text>
            </li>
          </ul>
          <!-- <div
            v-for="(product, index) in failedProductsContent"
            :key="'product-' + index"
          >
            <v-card-text>{{ product.title }}</v-card-text>

            <v-card-text
              v-for="(file, fileIndex) in product.fileKeys"
              :key="'product-' + index + '-file-' + fileIndex"
            >
              {{ file }}
            </v-card-text>
          </div> -->
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeProductContentVerify"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogAddon" max-width="500px">
      <v-card>
        <v-form
          ref="addonForm"
          v-model="addonValid"
          @submit.prevent="saveAddon"
        >
          <v-card-title>
            <span class="text-h5">{{ addonFormTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="editedAddon.type"
                    :items="addonTypes"
                    item-text="title"
                    item-value="value"
                    label="Type"
                    :rules="formRules.addonType"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedAddon.title"
                    label="Title"
                    :rules="formRules.title"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedAddon.price"
                    label="Price"
                    type="number"
                    prefix="R"
                    :rules="formRules.addonPrice"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedAddon.url"
                    label="Video"
                    hint='Eg. Vimeo: "1031522389", YouTube: "c_GorHGJ9Qg"'
                    :rules="formRules.validateVideoId"
                    clearable
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" class="d-flex flex-column">
                  <span class="text-h6">Addon File</span>
                  <div v-if="editedAddon.fileKey" class="mb-2">
                    <v-chip close @click:close="confirmDeleteAddonFile">
                      {{ getFileNameFromKey(editedAddon.fileKey) }}
                    </v-chip>
                  </div>
                  <v-btn
                    color="primary"
                    @click="uploadAddonFileClick"
                    :disabled="offline || loading"
                    :loading="uploadingAddonFile"
                  >
                    {{ editedAddon.fileKey ? "Replace File" : "Upload File" }}
                  </v-btn>
                  <input
                    type="file"
                    ref="addonFileInput"
                    style="display: none"
                    @change="uploadAddonFile"
                  />
                </v-col> -->
                <v-col cols="12">
                  <v-text-field
                    :value="addonFileName"
                    label="File"
                    readonly
                    @click="uploadAddonFile"
                    clearable
                    @click:clear="removeAddonFile"
                    :disabled="offline || loading || editedAddonIndex === -1"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              :disabled="loading"
              @click="closeAddonDialog"
            >
              Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!addonValid || loading"
              :loading="loading"
              type="submit"
            >
              Done
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogAddonFileDelete" max-width="500px">
      <v-card>
        <v-card-title class="justify-center"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="loading"
            @click="closeAddonFileDelete"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="loading"
            :loading="loading"
            @click="deleteAddonFile"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogDeleteAddon" max-width="500px">
      <v-card>
        <v-card-title class="justify-center"
          >Are you sure you want to delete this addon?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="deletingAddon"
            @click="closeDeleteAddon"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="deletingAddon"
            :disabled="deletingAddon"
            @click="deleteAddonConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogRecommendation" max-width="500px">
      <v-card>
        <v-form
          ref="recommendationForm"
          v-model="recommendationValid"
          @submit.prevent="saveRecommendation"
        >
          <v-card-title>
            <span class="text-h5">{{ recommendationFormTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedRecommendation.productId"
                    label="Product"
                    :items="availableProductsAndBundles"
                    item-text="title"
                    item-value="id"
                    :search-input.sync="recommendationSearch"
                    :filter="recommendationFilter"
                    :rules="formRules.productId"
                    required
                    clearable
                  >
                    <template v-slot:prepend-inner>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-on="on" v-bind="attrs">
                            <v-checkbox
                              v-model="smartRecommendationFilter"
                              hide-details
                              class="mt-0 pt-0 me-2"
                              @click.stop
                            ></v-checkbox>
                          </div>
                        </template>
                        <span
                          >Filter products to same category and next term
                          categories</span
                        >
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedRecommendation.discountPercentage"
                    label="Discount Percentage"
                    type="number"
                    suffix="%"
                    :rules="formRules.discountPercentage"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="secondary"
              class="black--text"
              @click="closeRecommendation"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="saveRecommendation"
              :disabled="!recommendationValid || loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogDeleteRecommendation" max-width="500px">
      <v-card>
        <v-card-title class="justify-center"
          >Are you sure you want to delete this recommendation?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="deletingItem"
            @click="closeDeleteRecommendation"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="deletingItem"
            :disabled="deletingItem"
            @click="deleteRecommendationConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="sharedSnackbar"
      min-width="auto"
      top
      elevation="10"
      timeout="2000"
      rounded="pill"
      color="secondary"
    >
      <div class="text-center">Product URL copied!</div>
    </v-snackbar>
    <v-snackbar
      v-model="copiedIDSnackbar"
      min-width="auto"
      top
      elevation="10"
      timeout="2000"
      rounded="pill"
      color="secondary"
    >
      <div class="text-center">Product ID copied!</div>
    </v-snackbar>

    <v-snackbar
      v-model="snackbar"
      min-width="auto"
      elevation="10"
      :color="snackbarColor"
      timeout="5000"
      top
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
  DataStore,
  Storage,
  SortDirection,
  API,
  // , Predicates
} from "aws-amplify";
import AWS from "aws-sdk";

import {
  Product,
  ProductContent,
  ProductTag,
  ProductCategory,
  ProductSEO,
  ProductBundle,
  Redirect,
} from "@/models";
import _ from "lodash";
import draggable from "vuedraggable";
import RichTextEditor from "@/components/global-components/rich-text-editor/RichTextEditor.vue";
import axios from "axios";
import store from "@/store";
// import { getUrl } from "aws-amplify/storage";
import { reconfigureDatastore } from "@/plugins/datastore/config.js";
import * as mutations from "@/graphql/mutations";
// import * as queries from "@/graphql/queries";

const NO_SUBJECT = "__none__";

export default {
  name: "AdminHolidays",
  components: {
    draggable,
    RichTextEditor,
  },
  data: () => ({
    sharedSnackbar: false,
    copiedIDSnackbar: false,
    initiallyLoaded: false,

    loadingGoogle: false,
    loadingSEOs: false,
    loadingCheck: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",

    isProductImgMenuOpen: false,
    productImgHoveringIndex: -1,

    expQuestionPanels: 0,

    // productSubscription: null,
    syncedRedirectArray: [],
    syncedProductSEOArray: [],
    syncedProductBundleArray: [],
    syncedProducts: false,
    syncedProductArray: [],
    unfilteredProductsArray: [],

    selectedProducts: [],
    savingSelectedProducts: false,

    //Recommendations ------------------
    editedRecommendations: [],
    unEditedRecommendations: [],
    dialogRecommendation: false,
    editedRecommendation: { productId: null, discountPercentage: 5 },
    defaultRecommendation: { productId: null, discountPercentage: 5 },
    editedRecommendationIndex: -1,
    recommendationValid: false,
    recommendationSearch: "",
    dialogDeleteRecommendation: false,
    recommendationHeaders: [
      { text: "Product Title", value: "title" },
      { text: "Discount %", value: "discountPercentage" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    nextTermCategoryIds: {},
    smartRecommendationFilter: true,
    //Recommendations-END ------------------

    //Addons ------------------
    dialogAddon: false,
    dialogAddonFileDelete: false,
    addonValid: false,
    editedAddon: {
      type: "",
      title: "",
      price: 0,
      fileKey: null,
      url: null,
    },
    editedAddonIndex: -1,
    editedAddons: [],
    unEditedAddons: [],
    uploadingAddonFile: false,
    originalAddonFileKey: null,
    dialogDeleteAddon: false,
    deletingAddon: false,

    addonTypes: [
      { title: "B&W", value: "b&w" },
      { title: "Economic", value: "economic" },
      { title: "Audio", value: "audio" },
      { title: "Dyslexia", value: "dyslexia" },
      { title: "Simplified", value: "simplified" },
      { title: "Editable", value: "editable" },
    ], // customize as needed
    addonHeaders: [
      { text: "Type", value: "type" },
      { text: "Title", value: "title" },
      { text: "Price", value: "price" },
      { text: "URL", value: "url" },
      { text: "File", value: "fileKey" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    //Addons-END ------------------

    //Bulk Edit ------------------
    bulkEditLoading: null,
    expBulkEditPanels: 0,
    bulkEditAll: false,

    bulkEditPublishDate: "",
    bulkEditPublishTime: "",
    bulkEditPublishDateTime: null,
    bulkEditDateTimeDialog: false,
    bulkEditDateTimeTab: "date",

    bulkEditPriceChangePercent: null,
    bulkEditPriceChangeValue: null,

    bulkEditDiscountPercent: null,

    bulkEditSubscriptionProduct: false,
    bulkEditECommerceProduct: false,
    bulkEditPhysicalProduct: false,
    //Bulk Edit-END ------------------

    productContentProductId: "",
    // productContentSubscription: null,
    syncedProductContentArray: [],

    uploadingFiles: [],

    productContentDatamodel: null,
    productContentFileKeys: [],
    productContentUrls: [],
    loading: false,

    valid: false,

    datetimeDialog: false,
    dateTimeTab: "date",
    productPublishDate: "",
    productPublishTime: "",

    dialog: false,
    dialogDelete: false,
    dialogCancel: false,
    dialogProductContentDelete: false,
    dialogProductContentVerify: false,

    failedProductsContent: [],
    productsContentCheckProgress: null,

    //Tags ------------------
    dialogManageProductTags: false,
    dialogEditProductTag: false,
    dialogDeleteProductTag: false,
    tagsSearch: "",

    syncedProductTagArray: [],
    productTagNameArray: [],
    // tagSubscription: null,

    editedProductTagIndex: -1,
    editedProductTagItem: {
      name: "",
    },
    defaultProductTagItem: {
      name: "",
    },

    tagHeaders: [
      { text: "Name", value: "name" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    tagSortBy: "name",
    tagSortDesc: true,
    //Tags-END ------------------

    //Categories ------------------
    dialogManageProductCategories: false,
    dialogEditProductCategory: false,
    dialogDeleteProductCategory: false,
    categoriesSearch: "",

    syncedProductCategories: false,
    syncedProductCategoryArray: [],
    // productCategoryNameArray: [],
    // categorySubscription: null,

    gradeArray: [
      "R",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],

    editedProductCategoryIndex: -1,
    editedProductCategoryItem: {
      id: "",
      name: "",
      slug: "",
      grade: "",
      parentId: "",
    },
    defaultProductCategoryItem: {
      id: "",
      name: "",
      slug: "",
      grade: "",
      parentId: "",
    },

    categoryHeaders: [
      { text: "Name", value: "name" },
      { text: "Grade", value: "grade" },
      { text: "Slug", value: "slug" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    categorySortBy: "name",
    categorySortDesc: true,
    //Categories-END ------------------

    productsDataTableSearchSubjects: [],

    deletingItem: false,
    cancelingChanges: false,

    sortBy: "title",
    sortDesc: true,
    productsDataTableSearch: "",
    productsDataTableSearchTags: [],
    productsDataTableSearchCategories: [],
    productsDataTablePageCount: 1,
    productsDataTableRowsPerPage: 10,
    productsDataTableServerItemsLength: 0,
    searchProductCategoriesMenu: false,
    editProductCategoriesMenu: false,
    editCategoryParentMenu: false,

    searchPhysicalProduct: false,
    searchECommerceProduct: false,
    searchSubscriptionProduct: false,
    searchMissingProductContent: false,
    showOnlySoftDeleted: false,

    headers: [
      { text: "Title", value: "title" },
      { text: "SKU", value: "sku" },
      { text: "Price", value: "price" },
      { text: "Featured", value: "featured" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    products: [],
    thumbnailImagesSrc: [],

    editedIndex: -1,

    unEditedProduct: {},

    editedItem: {
      title: "",
      description: "",
      price: null,
      discountPercentage: null,
      thumbnails: [],
      tags: [],
      questions: [],
      publishDate: null,
      featured: false,
      physical: false,
      subscriptionProduct: false,
      eCommerceProduct: false,
      searchField: "",
      sku: "",
      categoryId: "",
      subjectID: null,
      videoPreview: "",
      recommendations: [],
    },
    defaultItem: {
      title: "",
      description: "",
      price: null,
      discountPercentage: null,
      thumbnails: [],
      tags: [],
      questions: [],
      publishDate: null,
      featured: false,
      physical: false,
      subscriptionProduct: false,
      eCommerceProduct: false,
      searchField: "",
      sku: "",
      categoryId: "",
      subjectID: null,
      videoPreview: "",
      recommendations: [],
    },

    formRules: {
      productId: [(v) => !!v || "Product is required"],
      discountPercentage: [
        (v) => (v >= 0 && v <= 100) || "Discount must be between 0 and 100",
      ],
      addonType: [(v) => !!v || "Type is required"],
      addonPrice: [
        (v) => !!v || "Price is required",
        (v) =>
          (!isNaN(v) && (typeof v === "number" ? v : parseFloat(v)) >= 0) ||
          "Price must be a non-negative number",
      ],
      publishDate: [(v) => !!v || "Publish Date is required"],
      title: [(v) => !!v || "Title is required"],
      tagName: [(v) => !!v || "Tag name is required"],
      categoryName: [(v) => !!v || "Category name is required"],
      category: [(v) => !!v || "a Category is required"],
      hint: [(v) => !!v || "Hint is required"],
      placeholder: [(v) => !!v || "Placeholder is required"],
      type: [(v) => !!v || "Type is required"],
      label: [(v) => !!v || "Label is required"],
      validateVideoId: [
        // (v) =>
        //   (Array.isArray(v) && v.length > 0) ||
        //   "At least one video ID is required", // Ensure array is not empty
        (v) => {
          if (!v) return true;

          const youtubeRegex = /^[a-zA-Z0-9_-]{11}$/; // YouTube ID regex
          const vimeoRegex = /^[0-9]+$/; // Vimeo ID regex

          if (!Array.isArray(v)) {
            return (
              youtubeRegex.test(v) ||
              vimeoRegex.test(v) ||
              "Video ID is invalid. Use a YouTube or Vimeo ID."
            );
          }

          return (
            v?.every((id) => {
              return youtubeRegex.test(id) || vimeoRegex.test(id);
            }) || "One or more video IDs are invalid. Use YouTube or Vimeo IDs."
          );
        },
      ],
      // categorySlug: [
      //   (v) => !!v || "Category slug is required",
      //   (v) => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(v) || "Invalid slug format",
      // ],
    },

    formFieldTypes: [
      "Text",
      "Textarea",
      "Select",
      "Multi Select",
      "Radio",
      "Checkbox",
    ],
    productSearchExcludeFields: [
      "id",
      "fileKeys",
      "thumbnails",
      "searchField",
      "categoryId",
      "subjectID",
      "createdAt",
      "featured",
      "physical",
      "subscriptionProduct",
      "eCommerceProduct",
      "publishDate",
      "updatedAt",
      "_version",
      "_lastChangedAt",
      "_deleted",
    ],
  }),

  computed: {
    ...mapState({
      // subjectsLoaded: (state) => state.subjectsLoaded,
      loadingSubjects: (state) => state.loadingSubjects,
      offline: (state) => !state.isOnline,
      datastorePredicates: (state) => state.datastorePredicates,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
      datastoreReady: (state) => state.datastoreReady,
      startedDatastoreSync: (state) => state.startedDatastoreSync,
      userGroups: (state) => state.userGroups,
    }),

    ...mapGetters(["sortedSubjects"]),

    // "No subject assigned" comes first so you can find everything still
    // waiting to be tagged for school packages.
    subjectFilterItems() {
      return [
        { id: NO_SUBJECT, grade: null, subject: null },
        ...this.sortedSubjects,
      ];
    },

    subjectsByID() {
      const lookup = {};
      for (const subject of this.sortedSubjects) {
        lookup[subject.id] = subject;
      }
      return lookup;
    },

    recommendationFormTitle() {
      return this.editedRecommendationIndex === -1
        ? "New Recommendation"
        : "Edit Recommendation";
    },

    //todo - modify availableProductsAndBundles .filter to only include
    // - products in the same category and
    // - products in the next terms categories for the same grade and subject - using getNextTermCategoryIds
    // - defult discount to 5%

    availableProductsAndBundles() {
      return [...this.unfilteredProductsArray, ...this.syncedProductBundleArray]
        .filter(
          (p) =>
            p.id !== this.editedItem.id &&
            !this.editedRecommendations.some(
              (r, i) =>
                r.productId === p.id && i !== this.editedRecommendationIndex,
            ),
        )
        .filter((p) => {
          // Filter by this.nextTermCategoryIds
          const editedCategoryId = this.editedItem.categoryId;
          const nextTermCategoryIds =
            this.nextTermCategoryIds[editedCategoryId] || [];

          const isInSameCategory = p.categoryId === editedCategoryId;
          const isInNextTermCategories = nextTermCategoryIds.includes(
            p.categoryId,
          );

          return (
            !this.smartRecommendationFilter ||
            isInSameCategory ||
            isInNextTermCategories
          );
        });
    },

    addonFileName() {
      return this.editedAddon?.fileKey
        ? this.getFileNameFromKey(this.editedAddon.fileKey)
        : "";
    },

    checkingProductsProgressText() {
      const progress = this.productsContentCheckProgress;

      if (progress.total > 0) {
        if (progress.current >= progress.total) {
          return `Checked products ${progress.total} of ${progress.total} - DONE`;
        } else {
          return `Checking products ${progress.current} of ${progress.total} - ${progress.percentage}%`;
        }
      } else {
        return "";
      }
    },

    uploadingFilesText() {
      //like 'Uploading files i of .length - percentage%' one at a time untill 'Uploading files .length of .length - 100%'

      if (this.uploadingFiles.length > 0) {
        const firstFileStillUploadingIndex = this.uploadingFiles.findIndex(
          (file) => file.percentageUploaded < 100,
        );

        if (firstFileStillUploadingIndex === -1) {
          return `Uploaded files ${this.uploadingFiles.length} of ${
            this.uploadingFiles.length
          } - ${this.loading ? "Completing" : "DONE"}`;
        } else {
          return `Uploading files ${firstFileStillUploadingIndex + 1} of ${
            this.uploadingFiles.length
          } - ${
            this.uploadingFiles[firstFileStillUploadingIndex].percentageUploaded
          }%`;
        }
      } else {
        return "";
      }
    },

    categoryParentTree() {
      // Assuming syncedProductCategoryArray contains flat array of categories
      // with parentId indicating hierarchy, transform it into a tree-like structure
      return this.buildCategoryTree(
        this.syncedProductCategoryArray,
        this.editedProductCategoryItem.id
          ? this.editedProductCategoryItem.id
          : "",
      );
    },

    categoryTree() {
      // Assuming syncedProductCategoryArray contains flat array of categories
      // with parentId indicating hierarchy, transform it into a tree-like structure
      return this.buildCategoryTree(this.syncedProductCategoryArray);
    },

    // computedProductCategoryArray: {
    //   get: function () {
    //     return this.syncedProductCategoryArray.map((category) => {
    //       let parentCategories = [];

    //       if (category.parentId) {
    //         let currentCategory = category;
    //         while (currentCategory.parentId) {
    //           const parentCategory = this.syncedProductCategoryArray.find(
    //             (category) => category.id === currentCategory.parentId
    //           );
    //           if (parentCategory) {
    //             parentCategories.unshift(parentCategory.name);
    //             currentCategory = parentCategory;
    //           } else {
    //             break;
    //           }
    //         }
    //       }

    //       return parentCategories.length > 0
    //         ? parentCategories.join("/") + "/" + category.name
    //         : category.name;
    //     });
    //   },
    // },

    computedEditProductsCategoriesValue: {
      get: function () {
        const category = this.syncedProductCategoryArray.find(
          (category) => category.id === this.editedItem.categoryId,
        );

        if (category) {
          let parentCategories = [];

          if (category.parentId) {
            let currentCategory = category;
            while (currentCategory.parentId) {
              const parentCategory = this.syncedProductCategoryArray.find(
                (category) => category.id === currentCategory.parentId,
              );
              if (parentCategory) {
                parentCategories.unshift(parentCategory.name);
                currentCategory = parentCategory;
              } else {
                break;
              }
            }
          }

          return parentCategories.length > 0
            ? parentCategories.join("/") + "/" + category.name
            : category.name;
        } else return "";
      },
    },

    editedItemComputedCategory: {
      get: function () {
        return [this.editedItem.categoryId];
      },
    },

    // computedProductCategoryParentArray: {
    //   get: function () {
    //     const categories = this.syncedProductCategoryArray.filter(
    //       (category) => {
    //         if (this.editedProductCategoryItem.id) {
    //           // If editedProductCategoryItem has an ID, filter out categories with the same ID
    //           if (category.id === this.editedProductCategoryItem.id) {
    //             return false;
    //           }

    //           // Check if any parent category's ID matches the current category's ID
    //           let parentCategoryId = category.parentId;
    //           while (parentCategoryId) {
    //             const parentCategory = this.syncedProductCategoryArray.find(
    //               (cat) => cat.id === parentCategoryId
    //             );
    //             if (parentCategory) {
    //               if (parentCategory.id === this.editedProductCategoryItem.id) {
    //                 return false;
    //               }
    //               parentCategoryId = parentCategory.parentId;
    //             } else {
    //               break;
    //             }
    //           }

    //           return true;
    //         } else {
    //           // If editedProductCategoryItem has no ID, return all categories
    //           return true;
    //         }
    //       }
    //     );

    //     return categories.map((category) => {
    //       let parentCategories = [];

    //       if (category.parentId) {
    //         let currentCategory = category;
    //         while (currentCategory.parentId) {
    //           const parentCategory = this.syncedProductCategoryArray.find(
    //             (category) => category.id === currentCategory.parentId
    //           );
    //           if (parentCategory) {
    //             parentCategories.unshift(parentCategory.name);
    //             currentCategory = parentCategory;
    //           } else {
    //             break;
    //           }
    //         }
    //       }

    //       return parentCategories.length > 0
    //         ? parentCategories.join("/") + "/" + category.name
    //         : category.name;
    //     });
    //   },
    // },

    computedEditCategoryParentValue: {
      get: function () {
        const category = this.syncedProductCategoryArray.find(
          (category) => category.id === this.editedProductCategoryItem.parentId,
        );

        if (category) {
          let parentCategories = [];

          if (category.parentId) {
            let currentCategory = category;
            while (currentCategory.parentId) {
              const parentCategory = this.syncedProductCategoryArray.find(
                (category) => category.id === currentCategory.parentId,
              );
              if (parentCategory) {
                parentCategories.unshift(parentCategory.name);
                currentCategory = parentCategory;
              } else {
                break;
              }
            }
          }

          return parentCategories.length > 0
            ? parentCategories.join("/") + "/" + category.name
            : category.name;
        } else return "";
      },
      // set: function (newValue) {
      //   if (newValue) {
      //     let parentCategory = null;
      //     let newValueParts = newValue.split("/");
      //     for (let i = newValueParts.length - 1; i >= 0; i--) {
      //       const newCategory = newValueParts.slice(i).join("/");
      //       parentCategory = this.syncedProductCategoryArray.find(
      //         (category) => category.name === newCategory
      //       );
      //       if (parentCategory) {
      //         this.editedProductCategoryItem.parentId = parentCategory.id;
      //         break;
      //       }
      //     }
      //     // If no parent category found, set parent id to empty
      //     if (!parentCategory) {
      //       this.editedProductCategoryItem.parentId = "";
      //     }
      //   } else {
      //     this.editedProductCategoryItem.parentId = "";
      //   }
      // },
    },

    editedItemComputedTags: {
      get: function () {
        const editedItemTags = this.editedItem.tags
          ? this.editedItem.tags
              .map((tagId) => {
                const productTag = this.syncedProductTagArray.find(
                  (tag) => tag.id === tagId,
                );

                if (productTag) return productTag.name;
              })
              .filter((tag) => tag !== undefined)
          : [];
        return editedItemTags;
      },
      set: async function (newValue) {
        const updatedTags = [];
        for (const tag of newValue) {
          if (typeof tag === "string") {
            // If tag is a string, it's a new tag
            const existingTag = this.syncedProductTagArray.find(
              (t) => t.name === tag,
            );
            if (existingTag) {
              // If tag already exists, push its ID
              updatedTags.push(existingTag.id);
            } else {
              // If tag doesn't exist, create a new ProductTag model
              try {
                const newTag = await DataStore.save(
                  new ProductTag({ name: tag }),
                );
                this.productTagNameArray.push(newTag.name);
                updatedTags.push(newTag.id);
              } catch (error) {
                console.error("Error saving new tag:", error);
              }
            }
          }
        }

        this.editedItem.tags = updatedTags;
      },
    },

    productsSearchTags: {
      get: function () {
        let tags = [];
        _.forEach(this.productsDataTableSearchTags, (tagId) => {
          const productTag = _.find(this.syncedProductTagArray, { id: tagId });
          if (productTag) {
            tags.push(productTag);
          }
        });
        return tags;
      },
      set: function (newValue) {
        this.productsDataTableSearchTags = newValue;
      },
    },

    computedProductsSearchCategories: {
      get: function () {
        let categories = [];
        _.forEach(this.productsDataTableSearchCategories, (categoryId) => {
          const category = _.find(this.syncedProductCategoryArray, {
            id: categoryId,
          });
          if (category) {
            let parentCategories = [];

            if (category.parentId) {
              let currentCategory = category;
              while (currentCategory.parentId) {
                const parentCategory = this.syncedProductCategoryArray.find(
                  (category) => category.id === currentCategory.parentId,
                );
                if (parentCategory) {
                  parentCategories.unshift(parentCategory.name);
                  currentCategory = parentCategory;
                } else {
                  break;
                }
              }
            }

            categories.push(
              parentCategories.length > 0
                ? parentCategories.join("/") + "/" + category.name
                : category.name,
            );
          }
        });
        return categories;
      },
    },

    formTitle() {
      return this.editedIndex === -1 ? "New Product" : "Edit Product";
    },

    tagFormTitle() {
      return this.editedProductTagIndex === -1 ? "New Tag" : "Edit Tag";
    },

    categoryFormTitle() {
      return this.editedProductCategoryIndex === -1
        ? "New Category"
        : "Edit Category";
    },

    addonFormTitle() {
      return this.editedAddonIndex === -1 ? "New Addon" : "Edit Addon";
    },

    formattedProductPublishDate() {
      return this.editedItem.publishDate
        ? new Date(this.editedItem.publishDate).toLocaleString()
        : null;
    },

    formattedBulkEditPublishDate() {
      return this.bulkEditPublishDateTime
        ? new Date(this.bulkEditPublishDateTime).toLocaleString()
        : null;
    },

    productSaved() {
      let urlsEqual = true;
      if (this.productContentDatamodel?.urls?.length > 0) {
        urlsEqual = _.isEqual(
          this.productContentUrls,
          this.productContentDatamodel.urls,
        );
      } else if (
        !this.productContentUrls ||
        this.productContentUrls.length > 0
      ) {
        urlsEqual = false;
      }
      const addonsEqual = _.isEqual(this.editedAddons, this.unEditedAddons);
      const recommendationsEqual = _.isEqual(
        this.editedRecommendations,
        this.unEditedRecommendations,
      );
      const equal = _.isEqual(this.editedItem, this.unEditedProduct);
      return equal && urlsEqual && addonsEqual && recommendationsEqual;
    },

    productVat() {
      return this.editedItem.price
        ? Number.parseFloat(
            (this.editedItem.price / (1 + 0.15) - this.editedItem.price) * -1,
          ).toFixed(2)
        : 0;
    },
  },

  async mounted() {
    try {
      store.commit("changeDatastorePredicates", [
        {
          model: "ProductBundle",
          predicate: "Admin",
        },
        {
          model: "Product",
          predicate: "Admin",
        },
        {
          model: "Redirect",
          predicate: "Admin",
        },
        {
          model: "ProductSEO",
          predicate: "Admin",
        },
        {
          model: "ProductTag",
          predicate: "Admin",
        },
        {
          model: "ProductCategory",
          predicate: "Admin",
        },
        {
          model: "ProductContent",
          predicate: "Admin",
        },
      ]);

      if (!this.startedDatastoreSync || this.datastoreReady) {
        reconfigureDatastore();
      }

      store.dispatch("fetchSubjects");

      (this.formRules.title = [
        (v) => !!v || "Title is required",
        (v) =>
          (v && v.trim().length >= 3) || "Title must be at least 3 characters",
        (v) => {
          if (!v || !this.editedItem.categoryId) return true;
          const titleCategoryCombo = `${v.trim().toLowerCase()}_${
            this.editedItem.categoryId
          }`;
          const duplicateProduct = this.unfilteredProductsArray.find(
            (item) =>
              item.id !== this.editedItem.id &&
              `${item.title.trim().toLowerCase()}_${item.categoryId}` ===
                titleCategoryCombo,
          );
          const duplicateBundle = this.syncedProductBundleArray.find(
            (item) =>
              item.id !== this.editedItem.id &&
              `${item.title.trim().toLowerCase()}_${item.categoryId}` ===
                titleCategoryCombo,
          );
          if (duplicateProduct) {
            return "This title and category combination is already in use by a Product";
          }
          if (duplicateBundle) {
            return "This title and category combination is already in use by a Product Bundle";
          }
          return true;
        },
      ]),
        (this.headers = [
          {
            text: "Title",
            value: "title",
          },
          {
            text: "SKU",
            value: "sku",
          },

          { text: "Featured", value: "featured" },
          {
            text: "Price",
            value: "price",
          },
          {
            text: "Discount",
            value: "discountPercentage",
          },
          {
            text: "Category",
            value: "categoryId",
            sortable: false,
          },
          { text: "Subject", value: "subjectID", sortable: false },
          {
            text: "Publish Date",
            value: "publishDate",
          },
          {
            text: "Modified Date",
            value: "updatedAt",
          },
          {
            text: "Physical",
            value: "physical",
          },
          {
            text: "E-Com",
            value: "eCommerceProduct",
          },
          {
            text: "Subscription",
            value: "subscriptionProduct",
          },
          {
            text: "Files",
            value: "files",
            sortable: false,
          },
          {
            text: "Videos",
            value: "urls",
            sortable: false,
          },
          {
            text: "Soft Deleted",
            value: "softDeleted",
            sortable: false,
          },
          { text: "Actions", value: "actions", sortable: false },
        ]);

      this.tagHeaders = [
        {
          text: "Tag Name",
          value: "name",
          // sort: (a, b) => this.customSortProductTagName(a, b),
        },

        { text: "Actions", value: "actions", sortable: false },
      ];

      this.categoryHeaders = [
        {
          text: "Category Name",
          value: "name",
          // sort: (a, b) => this.customSortProductCategoryString(a, b),
        },
        {
          text: "Grade",
          value: "grade",
          sortable: false,
          // sort: (a, b) => this.customSortProductCategoryString(a, b),
        },
        {
          text: "Slug",
          value: "slug",
          // sort: (a, b) => this.customSortProductCategoryString(a, b),
        },

        { text: "Actions", value: "actions", sortable: false },
      ];

      if (!this.changingDatastoreConfig) {
        await this.syncData();
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (!this.initiallyLoaded) {
        this.initiallyLoaded = true;
      }
    }
  },

  watch: {
    changingDatastoreConfig: {
      async handler(newVal, oldVal) {
        // console.log("watch changingDatastoreConfig", newVal, oldVal);

        if (newVal === true) {
          return;
        }

        if (newVal === false) {
          await this.syncData();
        }
      },
      // deep: true,
    },

    dialog(val) {
      val || this.close();
    },

    dialogManageProductTags(val) {
      val || this.closeManageProductTags();
    },

    dialogEditProductTag(val) {
      val || this.closeEditProductTag();
    },

    dialogDeleteProductTag(val) {
      val || this.closeDeleteProductTag();
    },

    dialogManageProductCategories(val) {
      val || this.closeManageProductCategories();
    },

    dialogEditProductCategory(val) {
      val || this.closeEditProductCategory();
    },

    dialogDeleteProductCategory(val) {
      val || this.closeDeleteProductCategory();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },

    dialogProductContentVerify(val) {
      val || this.closeProductContentVerify();
    },

    sortDesc() {
      this.queryProducts();
    },

    sortBy() {
      this.queryProducts();
    },
  },

  methods: {
    subjectLabel(subject) {
      if (!subject) return "";
      if (subject.id === NO_SUBJECT) return "No subject assigned";
      return `Gr.${subject.grade} - ${subject.subject}`;
    },

    // Every word typed must appear somewhere in the grade or subject name,
    // in any order. "4 maths", "maths 4" and "4 mat" all work.
    subjectMatchesSearch(subject, searchText) {
      const subjectText = this.subjectLabel(subject).toLowerCase();
      const searchWords = (searchText || "").toLowerCase().split(" ");

      return searchWords.every((word) => subjectText.includes(word));
    },

    async loadSubjects() {
      this.loadingSubjects = true;
      try {
        let allSubjects = [];
        let nextToken = null;

        do {
          const result = await API.graphql({
            query: /* GraphQL */ `
              query ListSubjectsForProducts($nextToken: String) {
                listSubjects(limit: 1000, nextToken: $nextToken) {
                  items {
                    id
                    grade
                    subject
                    _deleted
                  }
                  nextToken
                }
              }
            `,
            variables: { nextToken },
            authMode: "AMAZON_COGNITO_USER_POOLS",
          });

          allSubjects = allSubjects.concat(result.data.listSubjects.items);
          nextToken = result.data.listSubjects.nextToken;
        } while (nextToken);

        this.subjects = allSubjects.filter(
          (subject) => subject && !subject._deleted,
        );
      } catch (error) {
        console.log("loadSubjects error:", error);
      } finally {
        this.loadingSubjects = false;
      }
    },

    async syncProductToMailchimp(product) {
      try {
        const seo = this.syncedProductSEOArray?.find?.(
          (s) => s.Product?.id === product.id,
        );
        await API.post("mailchimpnewsletterapi", "/item/sync-product", {
          body: {
            product: {
              id: product.id,
              title: product.title,
              url: seo ? `https://juffrouanri.com/${seo.seoId}` : undefined,
              variants: [
                {
                  id: product.id, // just mirror the product
                  title: product.title,
                },
              ],
            },
          },
        });
      } catch (err) {
        // Never let a Mailchimp hiccup break the admin save flow
        console.error("Mailchimp product sync failed:", err);
      }
    },

    async migrateProductSkusToString() {
      try {
        this.loading = true;

        // Pull the FULL synced set, not the filtered UI array
        const allProducts = await DataStore.query(Product);

        // Anything with a sku set (covers both N-still-locally-numeric
        // and AppSync-coerced-to-string cases — both need the write-back
        // to normalise DynamoDB's stored attribute type to S)
        const productsToFix = allProducts.filter(
          (p) => p.sku !== null && p.sku !== undefined && p.sku !== "",
        );

        console.log(
          `Found ${productsToFix.length} product(s) with a sku to convert`,
        );

        let updated = 0;
        let failed = 0;

        for (const product of productsToFix) {
          try {
            await DataStore.save(
              Product.copyOf(product, (updateModel) => {
                // Force a true string (idempotent: String("123") === "123")
                updateModel.sku = String(product.sku).trim();

                // Keep the search index consistent so search-by-sku works.
                // Build AFTER setting sku so the new value is included.
                updateModel.searchField = JSON.stringify(
                  _.values(
                    _.omit(updateModel, this.productSearchExcludeFields),
                  ),
                ).toLowerCase();
              }),
            );
            updated++;
            console.log(`✓ ${product.id} -> "${String(product.sku)}"`);
          } catch (err) {
            failed++;
            console.error(`✗ Failed for ${product.id}:`, err);
          }
        }

        console.log(
          `SKU migration complete. Updated: ${updated}, Failed: ${failed}`,
        );
      } catch (error) {
        console.error("migrateProductSkusToString error:", error);
      } finally {
        this.loading = false;
      }
    },

    async getNextTermCategoryIds(categoryIdArray = []) {
      if (!categoryIdArray.length || !this.syncedProductCategoryArray?.length)
        return {};

      const categories = this.syncedProductCategoryArray;
      const idToCat = new Map(categories.map((c) => [c.id, c]));

      // Pre-build children map for speed
      const childrenMap = new Map();
      categories.forEach((cat) => {
        const key = cat.parentId || "root";
        if (!childrenMap.has(key)) childrenMap.set(key, []);
        childrenMap.get(key).push(cat);
      });

      // SUPER ROBUST term detection & number extraction
      const isTermCategory = (name = "") =>
        /\b(term|kwartaal)\s*\d+/i.test(name);
      const extractTermNumber = (name = "") => {
        const match = name.toLowerCase().match(/\b(term|kwartaal)\s*(\d+)/i);
        return match ? parseInt(match[2], 10) : null;
      };

      const result = {};

      for (const id of categoryIdArray) {
        const currentCat = idToCat.get(id);
        console.log(`Processing category ID ${id}:`, currentCat);
        if (!currentCat) {
          result[id] = null;
          continue;
        }

        // Walk up to find Term ancestor
        let termAncestor = null;
        let node = currentCat;
        while (node) {
          if (isTermCategory(node.name)) {
            termAncestor = node;
            break;
          }
          console.log(
            `Category ID ${id} - walking up from ${node.name} to parent`,
          );
          if (!node.parentId) break;
          node = idToCat.get(node.parentId);
          console.log(
            `Category ID ${id} - moved up to parent:`,
            node ? node.name : "none",
          );
        }
        console.log(
          `Category ID ${id} - term ancestor:`,
          termAncestor ? termAncestor.name : "none",
        );

        if (!termAncestor) {
          result[id] = null;
          continue;
        }

        const currentTermNum = extractTermNumber(termAncestor.name);
        console.log(`Category ID ${id} - current term number:`, currentTermNum);
        if (!currentTermNum || currentTermNum < 1 || currentTermNum > 4) {
          result[id] = null;
          continue;
        }

        const nextTermNum = currentTermNum === 4 ? 1 : currentTermNum + 1;

        console.log(`Category ID ${id} - next term number:`, nextTermNum);

        // Find next term under same parent
        const subjectParentId = termAncestor.parentId;
        const nextTermCat = (childrenMap.get(subjectParentId) || []).find(
          (c) =>
            isTermCategory(c.name) && extractTermNumber(c.name) === nextTermNum,
        );

        if (!nextTermCat) {
          result[id] = null;
          continue;
        }
        console.log(
          `Category ID ${id} - next term category:`,
          nextTermCat.name,
        );

        // Rebuild path from current → term (excluding term)
        const pathNames = [];
        node = currentCat;
        while (node && node.id !== termAncestor.id) {
          if (node.name) pathNames.unshift(node.name);
          node = node.parentId ? idToCat.get(node.parentId) : null;
        }

        // Walk same path under next term
        let target = nextTermCat;
        let found = true;
        for (const name of pathNames) {
          const child = (childrenMap.get(target.id) || []).find(
            (c) => c.name === name,
          );
          if (!child) {
            found = false;
            break;
          }
          target = child;
        }

        result[id] = found ? target.id : null;
      }

      return result;
    },
    async updateReciprocalRecommendation(currentId, rec) {
      const { productId, discountPercentage } = rec;
      let otherModel, other;
      other = await DataStore.query(Product, productId).catch(() => null);
      if (other) {
        otherModel = Product;
      } else {
        other = await DataStore.query(ProductBundle, productId).catch(
          () => null,
        );
        if (other) {
          otherModel = ProductBundle;
        } else {
          console.error(`No product or bundle found with id ${productId}`);
          return;
        }
      }
      let otherRecs = other.recommendations
        ? _.cloneDeep(other.recommendations)
        : [];
      // console.log("otherRecs before update:", JSON.stringify(otherRecs));
      const existingIndex = otherRecs.findIndex(
        (r) => r.productId === currentId,
      );
      // console.log("existingIndex:", existingIndex);
      if (existingIndex !== -1) {
        otherRecs[existingIndex].discountPercentage = discountPercentage;
        // console.error(`Recommendation already exists for product ${productId}`);
        // return;
      } else {
        otherRecs.push({ productId: currentId, discountPercentage });
      }
      // console.log("otherRecs after update:", JSON.stringify(otherRecs));
      await DataStore.save(
        otherModel.copyOf(other, (updated) => {
          updated.recommendations = otherRecs.length > 0 ? otherRecs : null;
        }),
      );
    },

    recommendationFilter(item, queryText, itemText) {
      const searchText = queryText.toLowerCase();
      return (
        item.title.toLowerCase().includes(searchText) ||
        item.id.includes(searchText)
      );
    },

    getProductTitleById(id) {
      const product = this.unfilteredProductsArray.find((p) => p.id === id);
      return product
        ? product.title
        : this.syncedProductBundleArray.find((p) => p.id === id)?.title ||
            "Unknown Product";
    },

    async createRecommendation() {
      this.nextTermCategoryIds = await this.getNextTermCategoryIds([
        this.editedItem.categoryId,
      ]);
      console.log(
        "nextTermCategoryIds",
        this.nextTermCategoryIds,
        this.editedItem.categoryId,
      );
      this.editedRecommendation = _.cloneDeep(this.defaultRecommendation);
      this.editedRecommendationIndex = -1;
      this.dialogRecommendation = true;
    },

    async editRecommendation(item) {
      this.nextTermCategoryIds = await this.getNextTermCategoryIds([
        this.editedItem.categoryId,
      ]);
      console.log(
        "nextTermCategoryIds",
        this.nextTermCategoryIds,
        this.editedItem.categoryId,
      );
      this.editedRecommendationIndex = this.editedRecommendations.indexOf(item);
      this.editedRecommendation = _.cloneDeep(item);
      this.dialogRecommendation = true;
    },

    deleteRecommendation(item) {
      this.editedRecommendationIndex = this.editedRecommendations.indexOf(item);
      this.dialogDeleteRecommendation = true;
    },

    deleteRecommendationConfirm() {
      this.deletingItem = true;

      if (this.editedRecommendationIndex > -1) {
        this.editedRecommendations.splice(this.editedRecommendationIndex, 1);
      }

      this.deletingItem = false;
      this.closeDeleteRecommendation();
    },

    closeDeleteRecommendation() {
      this.dialogDeleteRecommendation = false;
      this.editedRecommendationIndex = -1;
      this.nextTermCategoryIds = {};
    },

    saveRecommendation() {
      if (this.editedRecommendationIndex > -1) {
        this.$set(
          this.editedRecommendations,
          this.editedRecommendationIndex,
          _.cloneDeep(this.editedRecommendation),
        );
      } else {
        this.editedRecommendations.push(_.cloneDeep(this.editedRecommendation));
      }

      this.closeRecommendation();
    },

    closeRecommendation() {
      this.dialogRecommendation = false;
      this.$nextTick(() => {
        this.editedRecommendation = _.cloneDeep(this.defaultRecommendation);
        this.editedRecommendationIndex = -1;
      });
    },

    deleteAddon(item) {
      this.editedAddonIndex = this.editedAddons.indexOf(item);
      this.dialogDeleteAddon = true;
    },
    closeDeleteAddon() {
      this.dialogDeleteAddon = false;
      this.$nextTick(() => {
        this.editedAddonIndex = -1;
      });
    },
    async deleteAddonConfirm() {
      this.deletingAddon = true;
      try {
        const addon = this.editedAddons[this.editedAddonIndex];
        const matchingUnedited = this.unEditedAddons.find(
          (a) => a.type === addon.type && a.title === addon.title,
        );
        const isNew = !matchingUnedited;
        if (isNew && addon.fileKey) {
          await Storage.remove(addon.fileKey, { level: "public" }).catch(
            (err) => console.log(err),
          );
        }
        this.editedAddons.splice(this.editedAddonIndex, 1);
        console.log("Deleted addon", addon);
        console.log("Updated editedAddons", this.editedAddons);
        console.log("Updated unEditedAddons", this.unEditedAddons);
      } catch (error) {
        console.log(error);
      } finally {
        this.deletingAddon = false;
        this.closeDeleteAddon();
      }
    },
    deleteAddonFile() {
      // Assuming this method exists; modify to handle file deletion without immediate DataStore save
      const oldFileKey = this.editedAddon.fileKey; // Assuming editedAddon is the current addon being edited in dialog
      if (oldFileKey) {
        const unEditedFileKeys = this.unEditedAddons
          .map((a) => a.fileKey)
          .filter(Boolean);
        const isNewFile = !unEditedFileKeys.includes(oldFileKey);
        if (isNewFile) {
          Storage.remove(oldFileKey, { level: "public" }).catch((err) =>
            console.log(err),
          );
        }
        this.editedAddon.fileKey = null;
      }
      this.closeAddonFileDelete();
    },
    saveAddon() {
      // Assuming this method exists; modify to update local editedAddons without DataStore save
      if (this.editedAddonIndex > -1) {
        this.$set(
          this.editedAddons,
          this.editedAddonIndex,
          _.cloneDeep(this.editedAddon),
        );
      } else {
        this.editedAddons.push(_.cloneDeep(this.editedAddon));
      }
      this.closeAddonDialog();
    },

    getFileNameFromKey(key) {
      return key ? key.split("/").pop() : "";
    },

    createAddon() {
      this.editedAddon = {
        type: "",
        title: "",
        price: 0,
        fileKey: null,
        url: null,
      };
      this.originalAddonFileKey = null;
      this.editedAddonIndex = -1;
      this.dialogAddon = true;
    },

    editAddon(item) {
      this.editedAddon = _.cloneDeep(item);
      this.originalAddonFileKey = item.fileKey || null;
      this.editedAddonIndex = this.editedAddons.indexOf(item);
      this.dialogAddon = true;
    },

    closeAddonDialog() {
      // if (
      //   this.editedAddon.fileKey &&
      //   this.editedAddon.fileKey !== this.originalAddonFileKey
      // ) {
      //   Storage.remove(this.editedAddon.fileKey).catch((err) =>
      //     console.log(err)
      //   );
      // }

      this.dialogAddon = false;
      this.$nextTick(() => {
        this.editedAddon = {
          type: "",
          title: "",
          price: 0,
          fileKey: null,
          url: null,
        };
        this.originalAddonFileKey = null;
        this.editedAddonIndex = -1;
      });
    },

    uploadAddonFileClick() {
      this.$refs.addonFileInput.click();
    },

    async uploadAddonFile() {
      try {
        console.log("uploadAddonFile");
        if (this.editedAddon?.fileKey > "") return;

        const inputElement = document.createElement("input");
        inputElement.type = "file";
        inputElement.accept = "*/*";

        inputElement.addEventListener("change", async (event) => {
          if (
            event.target instanceof HTMLInputElement &&
            event.target.files &&
            event.target.files.length > 0
          ) {
            this.loading = true;
            const file = event.target.files[0];
            let fileToUpload = file;
            let mimeType = file.type;
            const maxSize = 800;

            if (file.type.startsWith("image/") && file.type !== "image/gif") {
              fileToUpload = await this.resizeImage(file, maxSize);
              mimeType = "image/jpeg";
            }

            const newKey =
              "ProductsContent/" +
              this.productContentDatamodel.id +
              "/addons/" +
              Date.now() +
              "-" +
              file.name;

            const newPut = await Storage.put(newKey, fileToUpload, {
              contentType: mimeType,
            });

            this.editedAddon.fileKey = newPut.key;
            this.editedAddons[this.editedAddonIndex].fileKey = newPut.key;
            await this.saveAddonsToDataStore();

            this.loading = false;
          }
        });

        document.body.appendChild(inputElement);
        inputElement.click();
        document.body.removeChild(inputElement);
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    async removeAddonFile() {
      if (this.editedAddon.fileKey) {
        this.loading = true;
        await Storage.remove(this.editedAddon.fileKey, {
          level: "public",
        }).catch((err) => console.log(err));
        this.editedAddon.fileKey = null;
        this.editedAddons[this.editedAddonIndex].fileKey = null;
        await this.saveAddonsToDataStore();
        this.loading = false;
      }
    },

    async resizeImage(image, maxSize) {
      return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const img = new Image();
        img.onload = () => {
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxSize) {
              height *= maxSize / width;
              width = maxSize;
            }
          } else {
            if (height > maxSize) {
              width *= maxSize / height;
              height = maxSize;
            }
          }

          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              resolve(blob);
            },
            "image/jpeg",
            0.9,
          );
        };

        img.src = URL.createObjectURL(image);
      });
    },

    confirmDeleteAddonFile() {
      this.dialogAddonFileDelete = true;
    },

    closeAddonFileDelete() {
      this.dialogAddonFileDelete = false;
    },

    async saveAddonsToDataStore() {
      const productAddons = this.editedAddons.map((a) => ({
        type: a.type.trim(),
        title: a.title.trim(),
        price: typeof a.price === "string" ? parseFloat(a.price) : a.price,
      }));
      console.log("productAddons", productAddons);
      const contentAddons = this.editedAddons
        .map((a) => ({
          type: a.type.trim(),
          title: a.title.trim(),
          fileKey: a.fileKey || null,
          url: a.url ? a.url.trim() : null,
        }))
        .filter((a) => a.fileKey || a.url);
      console.log("contentAddons", contentAddons);

      this.editedItem.searchField = JSON.stringify(
        _.values(_.omit(this.editedItem, this.productSearchExcludeFields)),
      ).toLowerCase();

      await DataStore.save(
        Product.copyOf(
          _.find(this.unfilteredProductsArray, { id: this.editedItem.id }),
          (updateModel) => {
            updateModel.addons =
              productAddons.length === 0 ? null : productAddons;
            updateModel.searchField = this.editedItem.searchField;
          },
        ),
      );

      if (!this.productContentDatamodel && contentAddons.length > 0) {
        this.productContentDatamodel = await DataStore.save(
          new ProductContent({
            productId: this.editedItem.id,
            addons: contentAddons,
          }),
        );
      } else if (this.productContentDatamodel) {
        await DataStore.save(
          ProductContent.copyOf(this.productContentDatamodel, (c) => {
            c.addons = contentAddons.length === 0 ? null : contentAddons;
          }),
        );
      }

      this.unEditedAddons = _.cloneDeep(this.editedAddons);
    },

    getFilteredProductsAndBundles() {
      const searchTerms = this.productsDataTableSearch
        .split(" ")
        .map((str) => str.toLowerCase());
      const searchMissingProductContentProductIds =
        this.failedProductsContent.map((product) => product.id);

      const filterFn = (p) => {
        return (
          (this.productsDataTableSearchSubjects.length === 0 ||
            this.productsDataTableSearchSubjects.some((subjectID) =>
              subjectID === NO_SUBJECT ? !p.subjectID : p.subjectID === subjectID,
          )) &&
          this.productsDataTableSearchTags.every((tag) =>
            p.tags?.includes(tag),
          ) &&
          (this.productsDataTableSearchCategories.length === 0 ||
            this.productsDataTableSearchCategories.includes(p.categoryId)) &&
          (!this.searchMissingProductContent ||
            searchMissingProductContentProductIds.includes(p.id)) &&
          searchTerms.every((term) => p.searchField?.includes(term)) &&
          (!this.searchECommerceProduct || p.eCommerceProduct === true) &&
          (!this.searchPhysicalProduct || p.physical === true) &&
          (!this.searchSubscriptionProduct || p.subscriptionProduct === true)
        );
      };

      const filteredProducts = this.unfilteredProductsArray.filter(filterFn);

      return [...filteredProducts];
    },

    async bulkUpdateProducts(updates) {
      try {
        store.commit("removeSubscriptions", ["Product", "ProductBundle"]);

        const CHUNK_SIZE = 200;
        const chunks = _.chunk(updates, CHUNK_SIZE);
        for (const chunk of chunks) {
          try {
            const response = await API.post(
              "productactionsapi",
              "/item/bulk-update-products",
              {
                body: { updates: chunk },
              },
            );

            console.log("response", response);

            if (response.success) {
              this.snackbarText = `Successfully updated ${response.updatedCount} products!`;
              this.snackbarColor = "success";
              this.snackbar = true;
            } else {
              this.snackbarText = `Bulk update failed: ${response.errors.join(
                "; ",
              )}`;
              this.snackbarColor = "error";
              this.snackbar = true;
            }
          } catch (error) {
            console.error("Bulk update chunk failed:", error);
          }
        }
      } catch (error) {
        console.error("Error in bulkUpdateProducts:", error);
      } finally {
        console.log("Finished bulk updating products, resyncing data.");
        this.syncProducts();
        this.syncProductBundles();
      }
    },

    async createGoogleProduct() {
      try {
        this.loadingGoogle = true;
        for (const product of this.selectedProducts) {
          const existingProductSEO =
            this.syncedProductSEOArray.find(
              (seo) => seo.productID === product.id,
            ) || null;

          if (!existingProductSEO) return;

          const productLink = `${window.location.origin}/${existingProductSEO.seoId}`;

          const googleProductTags = this.syncedProductTagArray
            .filter((tag) => product.tags.includes(tag.id))
            .map((tag) => tag.name.trim().toUpperCase());

          const response = await API.post(
            "googlemerchantapi",
            "/item/insertGoogleProduct",
            {
              body: {
                product: product,
                link: productLink,
                tags: googleProductTags,
                // offerId: product.sku?.toString() || product.id
              },
            },
          ).catch((err) => {
            console.log("err:", err);
          });

          console.log("response", response);
          this.loading = false;

          if (response.success) {
            this.snackbarText =
              response.success || "Product added to Google successfully";
            this.snackbarColor = "success";
            this.snackbar = true;
            // Optionally handle googleResponse: response.data.googleResponse
          } else {
            this.snackbarText =
              response?.message || "Failed to add product to Google";
            this.snackbarColor = "error";
            this.snackbar = true;
          }
        }
      } catch (error) {
        this.snackbarText =
          error.response?.data?.error || "Failed to add product to Google";
        this.snackbarColor = "error";
        this.snackbar = true;
        console.error(
          "Error details:",
          error.response?.data?.details || error.message,
        );
      } finally {
        this.loadingGoogle = false;
      }
    },

    async createProductSEOs() {
      try {
        this.loadingSEOs = true;

        // Create a Map for faster lookups of existing ProductSEOs by productID
        const existingSEOMap = new Map(
          this.syncedProductSEOArray.map((seo) => [seo.productID, seo]),
        );

        // Filter products without SEOs using Map for O(1) lookup
        const productsWithoutSEOs = this.unfilteredProductsArray.filter(
          (product) => !existingSEOMap.has(product.id),
        );

        console.log(
          `Total products without SEOs: ${productsWithoutSEOs.length}`,
        );

        // Create a Map for category lookups
        const categoryMap = new Map(
          this.syncedProductCategoryArray.map((cat) => [cat.id, cat]),
        );

        // Chunk the array into groups of 10
        const chunks = (arr, size) =>
          Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
            arr.slice(i * size, i * size + size),
          );

        const productChunks = chunks(productsWithoutSEOs, 10);

        // Helper function to delay execution
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        // Process chunks sequentially with a delay
        for (const chunk of productChunks) {
          const promises = chunk.map(async (product, i) => {
            console.log(
              `Processing product ${i + 1} of ${chunk.length} in chunk`,
            );

            const productCategory = categoryMap.get(product.categoryId) || null;

            const seoId = `product/${this.generateSeoId(
              product.title,
              productCategory,
            )}`;
            if (!seoId) {
              console.warn(
                `Failed to generate seoId for product: ${product.id}`,
              );
              return;
            }

            const productSEODetails = {
              seoId,
              productID: product.id,
            };

            try {
              await API.graphql({
                query: mutations.createProductSEO,
                variables: { input: productSEODetails },
                authMode: "AMAZON_COGNITO_USER_POOLS",
              });
            } catch (err) {
              console.error(
                `Error creating ProductSEO for product ${product.id}:`,
                err,
              );
            }
          });

          // Run chunk promises concurrently
          await Promise.all(promises);

          // Add a short delay between chunks to prevent overload (e.g., 100ms)
          await delay(100);
        }

        console.log("Done creating ProductSEOs");
      } catch (error) {
        console.error("createProductSEOs error:", error);
      } finally {
        this.loadingSEOs = false;
      }
    },

    slugify(text) {
      // Slugify a string: lowercase, replace spaces and special chars with hyphens, remove extra hyphens
      return text
        .toLowerCase()
        .replace(/[^a-z0-9]/gi, "-")
        .replace(/-{2,}/g, "-")
        .replace(/^-+|-+$/g, "");
    },

    generateSeoId(productTitle, productCategory) {
      try {
        if (!productCategory) {
          console.warn(
            "Category not found for ID:",
            this.editedItem.categoryId,
          );
          return this.slugify(productTitle || "untitled");
        }

        // Build category slug hierarchy
        let categorySlugs = [
          productCategory.slug || this.slugify(productCategory.name),
        ];
        let currentCategory = productCategory;
        while (currentCategory.parentId) {
          const parentCategory = this.syncedProductCategoryArray.find(
            (cat) => cat.id === currentCategory.parentId,
          );
          if (!parentCategory) break;
          categorySlugs.unshift(
            parentCategory.slug || this.slugify(parentCategory.name),
          );
          currentCategory = parentCategory;
        }

        // Combine category slugs and product title
        const seoIdParts = [
          ...categorySlugs,
          this.slugify(productTitle || "untitled"),
        ];
        return seoIdParts.join("-");
      } catch (error) {
        console.error("Error generating seoId:", error);
        return "";
      }
    },

    async adminAppsyncUpdateProducts() {
      try {
        AWS.config.update({
          region: "eu-west-2",
          accessKeyId: "",
          secretAccessKey: "",
        });

        const dynamodb = new AWS.DynamoDB.DocumentClient();
        const tableName = "Product-dgn4tpp7m5aoldssjrf3kuc2pu-production"; // Your DynamoDB table
        let products = [];
        let lastEvaluatedKey = null;

        // Scan all products where 'type' does not exist
        do {
          const scanParams = {
            TableName: tableName,
            FilterExpression:
              "attribute_not_exists(#type) AND attribute_exists(#publishDate) AND #publishDate <> :null",
            ExpressionAttributeNames: {
              "#type": "type",
              "#publishDate": "publishDate",
            },
            ExpressionAttributeValues: {
              ":null": null,
            },
            ExclusiveStartKey: lastEvaluatedKey,
          };

          const scanResult = await dynamodb.scan(scanParams).promise();
          products = products.concat(scanResult.Items || []);
          lastEvaluatedKey = scanResult.LastEvaluatedKey;
        } while (lastEvaluatedKey);

        if (products.length === 0) {
          console.log("No products found without type.");
          return;
        }

        console.log(`Found ${products.length} products to update.`);

        // // Update products via GraphQL
        // for (const product of products) {
        //   const productDetails = {
        //     id: product.id, // Required for update
        //     type: 'Product', // Set the type field
        //     // Add other required fields if needed (e.g., _version for AppSync)
        //   };

        //   try {
        //     await API.graphql({
        //       query: mutations.updateProduct ,
        //       variables: { input: productDetails },
        //       authMode: 'AMAZON_COGNITO_USER_POOLS',
        //     });
        //     console.log(`Updated product ${product.id}`);
        //   } catch (error) {
        //     console.error(`Failed to update product ${product.id}:`, error);
        //   }
        // }

        const chunks = (arr, size) =>
          Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
            arr.slice(i * size, i * size + size),
          );
        const productChunks = chunks(products, 10); // Process 10 at a time
        for (const chunk of productChunks) {
          await Promise.all(
            chunk.map((product) =>
              API.graphql({
                query: mutations.updateProduct,
                variables: {
                  input: {
                    id: product.id,
                    type: "Product",
                    publishDate: product.publishDate || "",
                  },
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
              }),
            ),
          );
        }

        console.log("All products updated successfully.");
      } catch (error) {
        console.error("Error updating products:", error);
      }
    },

    async adminUpdateProducts() {
      try {
        console.log(
          "this.unfilteredProductsArray:",
          this.unfilteredProductsArray,
        );
        console.log(
          "this.unfilteredProductsArray.length:",
          this.unfilteredProductsArray.length,
        );
        this.savingSelectedProducts = true;

        for (const product of this.unfilteredProductsArray) {
          // if (product.type) continue;

          await DataStore.save(
            Product.copyOf(product, (updated) => {
              updated.type = "Product";
              //  updated.publishDate = product.publishDate || null;
            }),
          );
        }
        this.savingSelectedProducts = false;
      } catch (err) {
        console.log(err);
      }
    },

    copyProductID(product) {
      // Use the Web Share API to share a message, image, and URL
      if (navigator.share) {
        navigator
          .share({
            // title: heading,
            text: product.id,
            // url: shareUrl,
          })
          .then(() => {
            // console.log("Shared successfully.")
          })
          .catch(() => {
            // console.error("Error sharing:", error)
          });

        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(product.id).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      } else {
        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(product.id).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      }

      this.copiedIDSnackbar = true;
    },

    shareProduct(product) {
      const existingProductSEO =
        this.syncedProductSEOArray.find(
          (seo) => seo.productID === product.id,
        ) || null;

      if (!existingProductSEO) return;

      const shareUrl = `${window.location.origin}/${existingProductSEO.seoId}`;

      // Use the Web Share API to share a message, image, and URL
      if (navigator.share) {
        navigator
          .share({
            // title: heading,
            // text: message,
            url: shareUrl,
          })
          .then(() => {
            // console.log("Shared successfully.")
          })
          .catch(() => {
            // console.error("Error sharing:", error)
          });

        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(shareUrl).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      } else {
        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(shareUrl).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      }

      this.sharedSnackbar = true;
    },

    createBundle() {
      store.commit("changeProductBundleParams", {
        products: this.selectedProducts.map((product) => product.id),
      });

      this.$router.push("/admin/productbundles");
    },

    async checkDataStoreConfig() {
      try {
        const search = this.productsDataTableSearch.split(" ");

        const existingProductPVariables = this.datastorePredicates.find(
          (item) => item.model === "Product",
        )?.predicateVariables;

        const productPVariables = {
          search: search,
          productsDataTableSearchTags: this.productsDataTableSearchTags,
          productsDataTableSearchCategories:
            this.productsDataTableSearchCategories,
          searchECommerceProduct: this.searchECommerceProduct,
          searchPhysicalProduct: this.searchPhysicalProduct,
          searchSubscriptionProduct: this.searchSubscriptionProduct,
        };

        if (
          !existingProductPVariables ||
          JSON.stringify(existingProductPVariables) !==
            JSON.stringify(productPVariables)
        ) {
          console.log("changing predicate");
          store.commit("changeDatastorePredicate", {
            model: "Product",
            predicate: "Admin",
            predicateVariables: productPVariables,
          });

          await reconfigureDatastore();
        } else {
          console.log("No need to change predicate");

          await this.syncData();
        }

        return true;
      } catch (error) {
        console.log(error);

        return false;
      }
    },

    async changeProductsSearchQuery() {
      await this.queryProducts();
    },

    // Helper function to recursively collect category IDs
    collectCategoryIds(categoryId) {
      let ids = [];

      // Helper function to traverse categories
      function traverseCategories(currentId) {
        // Add the current category ID to the list
        ids.push(currentId);
        // Find all children whose parentId matches currentId
        const children = this.syncedProductCategoryArray.filter(
          (cat) => cat.parentId === currentId,
        );
        // Recursively traverse each child
        children.forEach((child) => traverseCategories.call(this, child.id));
      }

      traverseCategories.call(this, categoryId);

      return ids;
    },

    removeProductContentFileKey(index) {
      this.productContentFileKeys.splice(index, 1);

      this.changeEditedItemProductContent();
    },

    getMissingFilesCount(productId) {
      const failedProduct = this.failedProductsContent.find(
        (item) => item.id === productId,
      );
      return failedProduct ? failedProduct.fileKeys.length : 0; // Return 0 if no missing files
    },

    // Method to check if a file key should be colored red
    isFileKeyMissing(fileKey) {
      // console.log("this.editedItem.id", this.editedItem.id);
      const failedProduct = this.failedProductsContent.find(
        (product) => product.id === this.editedItem.id,
      );
      // console.log("failedProduct", failedProduct);
      return failedProduct && failedProduct.fileKeys.includes(fileKey);
    },

    async checkIfProductContentExists() {
      this.loadingCheck = true;
      this.failedProductsContent = [];

      // const currentDateTime = new Date().toISOString();

      // const mainCategoryId = this.productsDataTableSearchCategories[0];
      // const selectedCategoryIds = this.collectCategoryIds(mainCategoryId);

      const productsToCheck = this.unfilteredProductsArray;
      // .filter((product) =>
      //   selectedCategoryIds.includes(product.categoryId)
      // );

      // console.log("productsToCheck", productsToCheck);

      this.productsContentCheckProgress = {
        total: productsToCheck.length - 1,
        current: 0,
        percentage: 0,
      };

      const batchSize = 50;

      const updateProgress = (increment = 1) => {
        this.productsContentCheckProgress.current += increment;
        this.productsContentCheckProgress.percentage = Math.round(
          (this.productsContentCheckProgress.current /
            this.productsContentCheckProgress.total) *
            100,
        );
      };

      for (
        let batchStart = 0;
        batchStart < productsToCheck.length;
        batchStart += batchSize
      ) {
        const batch = productsToCheck.slice(batchStart, batchStart + batchSize);
        const fileKeysToCheck = [];

        batch.forEach((product) => {
          const productContent = this.syncedProductContentArray.find(
            (item) => item.productId === product.id,
          );

          if (productContent && productContent.fileKeys?.length > 0) {
            productContent.fileKeys.forEach((fileKey) => {
              fileKeysToCheck.push({ fileKey, product });
            });
          } else {
            if (product.publishDate) {
              // console.log(
              //   `Product ${product.id} - No product content found or no file keys`
              // );
              this.failedProductsContent.push({
                id: product.id,
                title: product.title,
                fileKeys: [],
              });
            }
            updateProgress();
          }
        });

        const chunkSize = 10;
        for (
          let chunkStart = 0;
          chunkStart < fileKeysToCheck.length;
          chunkStart += chunkSize
        ) {
          const chunk = fileKeysToCheck.slice(
            chunkStart,
            chunkStart + chunkSize,
          );

          const checkFilePromises = chunk.map(({ fileKey, product }) =>
            this.checkFileExistence(fileKey)
              .then((fileExists) => {
                return { fileKey, product, fileExists };
              })
              .catch(() => {
                return { fileKey, product, fileExists: false };
              }),
          );

          const checkFileResults = await Promise.all(checkFilePromises);

          checkFileResults.forEach(({ fileKey, product, fileExists }) => {
            // console.log(
            //   `Product ${product.id} - File ${fileKey} exists: ${fileExists}`
            // );
            if (!fileExists) {
              const existingFailedProduct = this.failedProductsContent.find(
                (item) => item.id === product.id,
              );

              if (existingFailedProduct) {
                existingFailedProduct.fileKeys.push(fileKey);
              } else {
                this.failedProductsContent.push({
                  id: product.id,
                  title: product.title,
                  fileKeys: [fileKey],
                });
              }
            }

            updateProgress();
          });
        }
      }

      // console.log("failedProductsContent", this.failedProductsContent);

      if (this.failedProductsContent.length > 0) {
        let position = this.headers.length - 2;
        this.headers.splice(position, 0, {
          text: "Missing files",
          value: "missingFiles",
          sortable: false,
        });

        this.products.sort((a, b) => {
          const missingFilesA = this.getMissingFilesCount(a.id) || 0; // default to 0 if undefined
          const missingFilesB = this.getMissingFilesCount(b.id) || 0; // default to 0 if undefined

          // Sorting by descending order (most missing files first)
          if (missingFilesA === missingFilesB) return 0;
          return missingFilesB - missingFilesA; // reverse the subtraction to sort most missing files first
        });
      }

      this.dialogProductContentVerify = true;
      this.searchMissingProductContent = true;
      await this.changeProductsSearchQuery();
      this.loadingCheck = false;
    },

    async checkFileExistence(fileKey) {
      try {
        const url = await this.getFileUrl(fileKey);
        // console.log("url", url);
        const response = await axios
          .get(url, {
            headers: { Range: "bytes=0-0" },
          })
          .catch(() => {
            // console.error("Error checking file existence:", error);
            return false;
          });
        // console.log("response", response);
        return response?.status === 206 || false; // Partial Content response indicates file exists
      } catch (error) {
        // console.error("Error checking file existence:", error);
        if (error.response && error.response.status === 404) {
          return false; // File does not exist
        } else {
          // console.error("Error checking file existence:", error);
          return false; // Treat any other error as file not existing
        }
      }
    },

    async getFileUrl(fileKey) {
      try {
        const url = await Storage.get(fileKey, {
          level: "public",
        });
        return url;
      } catch (error) {
        console.error("Error getting file URL:", error);
      }
    },

    formatDateTime(date) {
      if (!date) return "";
      return new Date(date).toISOString().replace("T", " ").split("Z")[0];
    },

    async validateForm() {
      setTimeout(() => {
        if (this.$refs.form) this.$refs.form.validate();
      }, 0);
    },

    async addQuestion() {
      try {
        const mutableObj = _.cloneDeep(this.editedItem);

        if (!mutableObj?.questions) mutableObj.questions = [];

        mutableObj.questions.push({
          type: "",
          label: "",
          value: "",
          hint: "",
          placeholder: "",
          items: [],
          required: false,
        });

        this.editedItem = _.cloneDeep(mutableObj);

        await this.validateForm();
      } catch (error) {
        console.log(error);
      }
    },

    removeQuestion(questionIndex) {
      try {
        const mutableObj = _.cloneDeep(this.editedItem);

        mutableObj.questions.splice(questionIndex, 1);

        this.editedItem = _.cloneDeep(mutableObj);
      } catch (error) {
        console.log(error);
      }
    },

    comboboxErrors(itemArray, questionType) {
      if (
        (questionType === "Select" || questionType === "Multi Select") &&
        itemArray.length < 1
      ) {
        return "Select values are required";
      } else if (questionType === "Radio" && itemArray.length < 1) {
        return "Radio values are required";
      } else if (questionType === "Checkbox" && itemArray.length < 1) {
        return "Checkbox values are required";
      } else return "";
    },

    async changePhysEcommSubSearch(value) {
      if (value === "physical") {
        this.searchSubscriptionProduct = false;
      } else if (value === "sub") {
        this.searchPhysicalProduct = false;
      }

      await this.changeProductsSearchQuery();
    },

    changePhysEcommSub(value) {
      if (value === "physical") {
        this.editedItem.subscriptionProduct = false;
      } else if (value === "sub") {
        this.editedItem.physical = false;
      }
    },

    changeBulkPhysEcommSub(value) {
      if (value === "physical") {
        this.bulkEditSubscriptionProduct = false;
      } else if (value === "sub") {
        this.bulkEditPhysicalProduct = false;
      }
    },

    async scheduleProducts() {
      this.bulkEditLoading = "schedule";
      try {
        let productsToUpdate = [];
        if (this.bulkEditAll) {
          productsToUpdate = this.getFilteredProductsAndBundles();
        } else {
          let productsToUpdate = this.unfilteredProductsArray.filter((p) =>
            this.selectedProducts.some((sp) => sp.id === p.id),
          );
          // Existing DataStore logic for selected only
          for (const product of productsToUpdate) {
            await DataStore.save(
              Product.copyOf(product, (updated) => {
                updated.publishDate = this.bulkEditPublishDateTime;
                updated.searchField = JSON.stringify(
                  _.values(_.omit(updated, this.productSearchExcludeFields)),
                ).toLowerCase();
              }),
            );
          }
          return;
        }

        const updates = productsToUpdate.map((p) => ({
          id: p.id,
          bundle: p.products ? true : false,
          publishDate: this.bulkEditPublishDateTime,
          searchField: JSON.stringify(
            _.values(_.omit(p, this.productSearchExcludeFields)),
          ).toLowerCase(),
          _version: p._version,
        }));
        await this.bulkUpdateProducts(updates);
      } catch (error) {
        console.log(error);
      }
      this.bulkEditLoading = null;
    },

    async unScheduleProducts() {
      this.bulkEditLoading = "unschedule";
      try {
        let productsToUpdate = [];
        if (this.bulkEditAll) {
          productsToUpdate = this.getFilteredProductsAndBundles();
        } else {
          let productsToUpdate = this.unfilteredProductsArray.filter((p) =>
            this.selectedProducts.some((sp) => sp.id === p.id),
          );
          // Existing DataStore logic for selected only
          for (const product of productsToUpdate) {
            await DataStore.save(
              Product.copyOf(product, (updated) => {
                updated.publishDate = null;
                updated.searchField = JSON.stringify(
                  _.values(_.omit(updated, this.productSearchExcludeFields)),
                ).toLowerCase();
              }),
            );
          }
          return;
        }

        const updates = productsToUpdate.map((p) => ({
          id: p.id,
          bundle: p.products ? true : false,
          publishDate: null,
          searchField: JSON.stringify(
            _.values(_.omit(p, this.productSearchExcludeFields)),
          ).toLowerCase(),
          _version: p._version,
        }));
        await this.bulkUpdateProducts(updates);
      } catch (error) {
        console.log(error);
      }
      this.bulkEditLoading = null;
    },

    async changeProductsPrice(direction) {
      this.bulkEditLoading = `${direction}_price`;
      try {
        let productsToUpdate = [];
        if (this.bulkEditAll) {
          productsToUpdate = this.getFilteredProductsAndBundles();
        } else {
          let productsToUpdate = this.unfilteredProductsArray.filter((p) =>
            this.selectedProducts.some((sp) => sp.id === p.id),
          );
          // Existing DataStore logic for selected only
          const changeValue = this.bulkEditPriceChangeValue
            ? parseFloat(this.bulkEditPriceChangeValue)
            : 0;
          const changePercent = this.bulkEditPriceChangePercent
            ? parseFloat(this.bulkEditPriceChangePercent) / 100
            : 0;
          const sign = direction === "increase" ? 1 : -1;
          for (const product of productsToUpdate) {
            let newPrice = product.price;
            if (changeValue) {
              newPrice += sign * changeValue;
            } else if (changePercent) {
              newPrice *= 1 + sign * changePercent;
            }
            newPrice = Math.round(newPrice * 100) / 100;
            await DataStore.save(
              Product.copyOf(product, (updated) => {
                updated.price = newPrice;
                updated.searchField = JSON.stringify(
                  _.values(_.omit(updated, this.productSearchExcludeFields)),
                ).toLowerCase();
              }),
            );
          }
          return;
        }
        const changeValue = this.bulkEditPriceChangeValue
          ? parseFloat(this.bulkEditPriceChangeValue)
          : 0;
        const changePercent = this.bulkEditPriceChangePercent
          ? parseFloat(this.bulkEditPriceChangePercent) / 100
          : 0;
        const sign = direction === "increase" ? 1 : -1;

        const updates = productsToUpdate.map((p) => {
          let newValue = p.price;
          if (changeValue) {
            newValue += sign * changeValue;
          } else if (changePercent) {
            newValue *= 1 + sign * changePercent;
          }
          newValue = Math.round(newValue * 100) / 100;

          return {
            id: p.id,
            bundle: p.products ? true : false,
            price: newValue,
            searchField: JSON.stringify(
              _.values(_.omit(p, this.productSearchExcludeFields)),
            ).toLowerCase(),
            _version: p._version,
          };
        });
        await this.bulkUpdateProducts(updates);
      } catch (error) {
        console.log(error);
      }
      this.bulkEditLoading = null;
    },

    async changeProductsType() {
      this.bulkEditLoading = "change_type";
      try {
        let productsToUpdate = [];
        if (this.bulkEditAll) {
          productsToUpdate = this.getFilteredProductsAndBundles();
        } else {
          let productsToUpdate = this.unfilteredProductsArray.filter((p) =>
            this.selectedProducts.some((sp) => sp.id === p.id),
          );
          // Existing DataStore logic for selected only
          for (const product of productsToUpdate) {
            await DataStore.save(
              Product.copyOf(product, (updated) => {
                updated.physical = this.bulkEditPhysicalProduct;
                updated.subscriptionProduct = this.bulkEditSubscriptionProduct;
                updated.eCommerceProduct = this.bulkEditECommerceProduct;
                updated.searchField = JSON.stringify(
                  _.values(_.omit(updated, this.productSearchExcludeFields)),
                ).toLowerCase();
              }),
            );
          }
          return;
        }

        const updates = productsToUpdate.map((p) => ({
          id: p.id,
          bundle: p.products ? true : false,
          physical: this.bulkEditPhysicalProduct,
          subscriptionProduct: this.bulkEditSubscriptionProduct,
          eCommerceProduct: this.bulkEditECommerceProduct,
          searchField: JSON.stringify(
            _.values(_.omit(p, this.productSearchExcludeFields)),
          ).toLowerCase(),
          _version: p._version,
        }));
        await this.bulkUpdateProducts(updates);
      } catch (error) {
        console.log(error);
      }
      this.bulkEditLoading = null;
    },

    async discountProducts() {
      this.bulkEditLoading = "discount";
      try {
        let productsToUpdate = [];
        if (this.bulkEditAll) {
          productsToUpdate = this.getFilteredProductsAndBundles();
        } else {
          let productsToUpdate = this.unfilteredProductsArray.filter((p) =>
            this.selectedProducts.some((sp) => sp.id === p.id),
          );

          const discountPercent = parseFloat(this.bulkEditDiscountPercent);
          for (const product of productsToUpdate) {
            await DataStore.save(
              Product.copyOf(product, (updated) => {
                updated.discountPercentage =
                  (product.price || 0) === 0 ||
                  this.bulkEditDiscountPercent === "0"
                    ? null
                    : parseFloat(this.bulkEditDiscountPercent);
                updated.searchField = JSON.stringify(
                  _.values(_.omit(updated, this.productSearchExcludeFields)),
                ).toLowerCase();
              }),
            );
          }
          return;
        }

        const updates = productsToUpdate.map((p) => ({
          id: p.id,
          bundle: p.products ? true : false,
          discountPercentage:
            (p.price || 0) === 0 || this.bulkEditDiscountPercent === "0"
              ? null
              : parseFloat(this.bulkEditDiscountPercent),
          searchField: JSON.stringify(
            _.values(_.omit(p, this.productSearchExcludeFields)),
          ).toLowerCase(),
          _version: p._version,
        }));
        await this.bulkUpdateProducts(updates);
      } catch (error) {
        console.log(error);
      }
      this.bulkEditLoading = null;
    },

    async featureProducts() {
      this.bulkEditLoading = "feature";
      try {
        let productsToUpdate = [];
        if (this.bulkEditAll) {
          productsToUpdate = this.getFilteredProductsAndBundles();
        } else {
          let productsToUpdate = this.unfilteredProductsArray.filter((p) =>
            this.selectedProducts.some((sp) => sp.id === p.id),
          );

          // Existing DataStore logic for selected only
          for (const product of productsToUpdate) {
            await DataStore.save(
              Product.copyOf(product, (updated) => {
                updated.featured = true;
                updated.searchField = JSON.stringify(
                  _.values(_.omit(updated, this.productSearchExcludeFields)),
                ).toLowerCase();
              }),
            );
          }
          return;
        }

        const updates = productsToUpdate.map((p) => ({
          id: p.id,
          bundle: p.products ? true : false,
          featured: true,
          searchField: JSON.stringify(
            _.values(_.omit(p, this.productSearchExcludeFields)),
          ).toLowerCase(),
          _version: p._version,
        }));
        await this.bulkUpdateProducts(updates);
      } catch (error) {
        console.log(error);
      }
      this.bulkEditLoading = null;
    },

    async unFeatureProducts() {
      this.bulkEditLoading = "unfeature";
      try {
        let productsToUpdate = [];
        if (this.bulkEditAll) {
          productsToUpdate = this.getFilteredProductsAndBundles();
        } else {
          let productsToUpdate = this.unfilteredProductsArray.filter((p) =>
            this.selectedProducts.some((sp) => sp.id === p.id),
          );
          // Existing DataStore logic for selected only
          for (const product of productsToUpdate) {
            await DataStore.save(
              Product.copyOf(product, (updated) => {
                updated.featured = false;
                updated.searchField = JSON.stringify(
                  _.values(_.omit(updated, this.productSearchExcludeFields)),
                ).toLowerCase();
              }),
            );
          }
          return;
        }

        const updates = productsToUpdate.map((p) => ({
          id: p.id,
          bundle: p.products ? true : false,
          featured: false,
          searchField: JSON.stringify(
            _.values(_.omit(p, this.productSearchExcludeFields)),
          ).toLowerCase(),
          _version: p._version,
        }));
        await this.bulkUpdateProducts(updates);
      } catch (error) {
        console.log(error);
      }
      this.bulkEditLoading = null;
    },

    getProductFileCount(productId) {
      const productContent = this.syncedProductContentArray.find(
        (content) => content.productId === productId,
      );
      return productContent?.fileKeys?.length > 0
        ? productContent.fileKeys.length
        : 0;
    },

    getProductURLCount(productId) {
      const productContent = this.syncedProductContentArray.find(
        (content) => content.productId === productId,
      );
      return productContent?.urls?.length > 0 ? productContent.urls.length : 0;
    },

    updateCategoryParent(val) {
      this.editedProductCategoryItem.parentId = val.length > 0 ? val[0] : "";
    },

    updateProductCategory(val) {
      this.editedItem.categoryId = val.length > 0 ? val[0] : "";
    },

    generateSlug() {
      // Function to generate slug from the name
      const slug = this.editedProductCategoryItem.name
        .toLowerCase()
        .replace(/[^a-z0-9]/gi, "-") // Replace non-alphanumeric characters with -
        .replace(/-{2,}/g, "-") // Replace multiple - with single -
        .replace(/^-+|-+$/g, ""); // Trim - from start and end
      this.editedProductCategoryItem.slug = slug;
    },

    toggleMenu() {
      this.searchProductCategoriesMenu = !this.searchProductCategoriesMenu;
    },

    toggleEditProductMenu() {
      this.editProductCategoriesMenu = !this.editProductCategoriesMenu;
    },

    toggleEditCategoryParentMenu() {
      this.editCategoryParentMenu = !this.editCategoryParentMenu;
    },

    buildCategoryTree(categories, propCategoryId) {
      let tree = [];

      // Create a map of categories by their ID for quicker access
      const categoryMap = {};
      categories.forEach((category) => {
        categoryMap[category.id] = { ...category, children: [] };
      });

      // Function to recursively build the tree
      const buildTree = (categoryId) => {
        const category = categoryMap[categoryId];
        if (!category) return null; // Return null if category not found

        // Check if the category meets the condition to be added to the tree
        if (propCategoryId > "" && category.id === propCategoryId) {
          // Skip adding this category and its children
          return;
        }

        // Recursively build children
        if (category.parentId) {
          const parentCategory = categoryMap[category.parentId];
          if (parentCategory) {
            parentCategory.children.push(category);
          }
        } else {
          tree.push(category); // Add to top-level tree if no parent
        }
      };

      // Build tree for each category
      categories.forEach((category) => {
        buildTree(category.id);
      });

      return tree;
    },

    closeProductContentDelete() {
      this.productContentFileKeys = _.cloneDeep(
        this.productContentDatamodel.fileKeys,
      );

      this.dialogProductContentDelete = false;
    },

    async deleteProductContent() {
      this.uploadingFiles = [];
      this.loading = true;

      for (const fileKey of this.productContentDatamodel.fileKeys) {
        if (!this.productContentFileKeys.includes(fileKey)) {
          await Storage.remove(fileKey, {
            level: "public",
          }).catch((err) => console.log(err));
        }
      }

      await DataStore.save(
        ProductContent.copyOf(this.productContentDatamodel, (content) => {
          content.fileKeys = this.productContentFileKeys;
        }),
      ).catch((err) => console.log(err));

      this.dialogProductContentDelete = false;
      this.loading = false;
    },

    changeEditedItemProductContent() {
      if (
        this.productContentFileKeys.length <
          this.productContentDatamodel.fileKeys.length &&
        !this.loading
      ) {
        this.dialogProductContentDelete = true;
      }
    },

    updateProductPublishDateTime(action) {
      if (action === "clear") {
        this.productPublishDate = null;
        this.productPublishTime = null;
        this.editedItem.publishDate = null;
      } else if (this.productPublishDate && this.productPublishTime) {
        this.editedItem.publishDate = new Date(
          new Date(
            this.productPublishDate + "T" + this.productPublishTime + ":00Z",
          ).getTime() -
            2 * 60 * 60 * 1000,
        ).toISOString();
      } else {
        this.editedItem.publishDate = null;
      }
    },

    updateBulkEditPublishDateTime(action) {
      if (action === "clear") {
        this.bulkEditPublishDate = null;
        this.bulkEditPublishTime = null;
        this.bulkEditPublishDateTime = null;
      } else if (this.bulkEditPublishDate && this.bulkEditPublishTime) {
        this.bulkEditPublishDateTime = new Date(
          new Date(
            this.bulkEditPublishDate + "T" + this.bulkEditPublishTime + ":00Z",
          ).getTime() -
            2 * 60 * 60 * 1000,
        ).toISOString();
      } else {
        this.bulkEditPublishDateTime = null;
      }
    },

    closeDateTimeDialog() {
      this.datetimeDialog = false;
      this.dateTimeTab = "date";
    },

    closeBulkEditDateTimeDialog() {
      this.bulkEditDateTimeDialog = false;
      this.bulkEditDateTimeTab = "date";
    },

    cancelWarning() {
      this.dialogCancel = true;
    },

    customSortPrice(a, b) {
      const priceA = parseFloat(a);
      const priceB = parseFloat(b);
      if (this.sortDesc) {
        return priceA - priceB;
      }
      return priceB - priceA;
    },

    customSortProductString(a, b) {
      if (!this.sortDesc) {
        return a.localeCompare(b);
      }
      return b.localeCompare(a);
    },

    customSortProductTagName(a, b) {
      if (!this.tagSortDesc) {
        return a.localeCompare(b);
      }
      return b.localeCompare(a);
    },

    // customSortProductCategoryString(a, b) {
    //   const valueA = a ? a : "";
    //   const valueB = b ? b : "";
    //   console.log("valueA:", valueA);
    //   console.log("valueB:", valueB);
    //   if (!this.categorySortDesc) {
    //     return valueA.localeCompare(valueB);
    //   }
    //   return valueB.localeCompare(valueA);
    // },

    productsDataTablePageCountUpdate(val) {
      if (val !== 0) {
        this.productsDataTablePageCount = val; // Convert to 0-based index
        this.queryProducts();
      }
    },

    formatPercentage(percent) {
      // Ensure the price is a valid number
      if (percent === null || percent === undefined || isNaN(percent)) {
        return "";
      }

      return `${percent}%`;
    },

    formatPrice(price) {
      // Ensure the price is a valid number
      if (price === null || price === undefined || isNaN(price)) {
        return "";
      }

      // Convert the price to a fixed-point notation with 2 decimals
      const formattedPrice = Number(price)
        ? parseFloat(price).toFixed(2)
        : price.toFixed(2);

      return `R ${formattedPrice}`;
    },

    formatCategoryId(categoryId) {
      const category = this.syncedProductCategoryArray.find(
        (category) => category.id === categoryId,
      );

      if (category) {
        let parentCategories = [];

        if (category.parentId) {
          let currentCategory = category;
          while (currentCategory.parentId) {
            const parentCategory = this.syncedProductCategoryArray.find(
              (category) => category.id === currentCategory.parentId,
            );
            if (parentCategory) {
              parentCategories.unshift(parentCategory.name);
              currentCategory = parentCategory;
            } else {
              break;
            }
          }
        }

        return parentCategories.length > 0
          ? parentCategories.join("/") + "/" + category.name
          : category.name;
      } else return "";
    },

    async deleteProductThumbnail(thumbnailKey) {
      // console.log("deleteProductThumbnail:", thumbnailKey);
      await Storage.remove(thumbnailKey, {
        level: "public",
      })
        .then(() => {
          const mutableThumbnails = _.cloneDeep(this.editedItem.thumbnails);
          _.remove(
            mutableThumbnails,
            (thumbnail) => thumbnail === thumbnailKey,
          );
          this.editedItem.thumbnails = mutableThumbnails;

          _.remove(
            this.thumbnailImagesSrc,
            (thumbnail) => thumbnail.key === thumbnailKey,
          );

          this.editedItem.searchField = JSON.stringify(
            _.values(_.omit(this.editedItem, this.productSearchExcludeFields)),
          ).toLowerCase();

          DataStore.save(
            Product.copyOf(
              _.find(this.unfilteredProductsArray, { id: this.editedItem.id }),
              (product) => {
                product.thumbnails = this.editedItem.thumbnails;
                product.searchField = this.editedItem.searchField;
              },
            ),
          );
        })
        .catch((err) => console.log(err));
    },

    mouseOver(index) {
      if (!this.isProductImgMenuOpen) {
        this.productImgHoveringIndex = index;
      }
    },

    mouseOut() {
      if (!this.isProductImgMenuOpen) {
        this.productImgHoveringIndex = -1;
      }
    },

    mouseOutMenu() {
      this.isProductImgMenuOpen = false;
      this.productImgHoveringIndex = -1;
    },

    getThumbnailImageSrc(thumbnailKey) {
      const thumbnailImgSrc = _.find(this.thumbnailImagesSrc, {
        key: thumbnailKey,
      });
      return thumbnailImgSrc ? thumbnailImgSrc.src : "";
    },

    async getThumbnailImage(productThumbnailkey) {
      const thumbnailImgSrc = await Storage.get(productThumbnailkey, {
        level: "public",
      });
      return thumbnailImgSrc;
    },

    async uploadThumbnailImage() {
      try {
        const inputElement = document.createElement("input");
        inputElement.type = "file";
        inputElement.accept = "image/*,.gif"; // Explicitly allow GIFs

        inputElement.addEventListener("change", async (event) => {
          if (
            event.target instanceof HTMLInputElement &&
            event.target.files &&
            event.target.files.length > 0
          ) {
            this.loading = true;
            const file = event.target.files[0];
            const maxSize = 800; // Maximum size for resizing non-GIF images
            let fileToUpload = file; // Default to original file
            let mimeType = file.type; // Preserve original MIME type

            // Function to resize non-GIF images
            const resizeImage = (image) => {
              return new Promise((resolve) => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                const img = new Image();
                img.onload = () => {
                  let width = img.width;
                  let height = img.height;

                  if (width > height) {
                    if (width > maxSize) {
                      height *= maxSize / width;
                      width = maxSize;
                    }
                  } else {
                    if (height > maxSize) {
                      width *= maxSize / height;
                      height = maxSize;
                    }
                  }

                  canvas.width = width;
                  canvas.height = height;

                  ctx.drawImage(img, 0, 0, width, height);

                  canvas.toBlob(
                    (blob) => {
                      resolve(blob);
                    },
                    "image/jpeg",
                    0.9,
                  ); // Non-GIFs resized to JPEG
                };

                img.src = URL.createObjectURL(image);
              });
            };

            // Check if the file is a GIF
            if (file.type === "image/gif") {
              // Skip resizing for GIFs to preserve animation
              fileToUpload = file;
              mimeType = "image/gif"; // Ensure GIF MIME type
            } else {
              // Resize non-GIF images
              fileToUpload = await resizeImage(file);
            }

            // Upload the file to S3
            const newThumbnailImgPut = await Storage.put(
              "Products/" +
                this.editedItem.id +
                "/" +
                Date.now() +
                "-" +
                file.name,
              fileToUpload,
              {
                contentType: mimeType, // Set the correct MIME type
              },
            ).catch((err) => {
              console.error("S3 upload error:", err);
              throw err;
            });

            if (!this.editedItem.thumbnails) {
              this.editedItem.thumbnails = [];
            }

            if (!this.editedItem.thumbnails.includes(newThumbnailImgPut.key)) {
              const mutableThumbnails = _.cloneDeep(this.editedItem.thumbnails);

              mutableThumbnails.push(newThumbnailImgPut.key);
              this.editedItem.thumbnails = mutableThumbnails;

              // Fetch the image source for the newly added thumbnail
              const thumbnailImgSrc = await this.getThumbnailImage(
                newThumbnailImgPut.key,
              );

              // Update the thumbnailImagesSrc array with the new source
              this.thumbnailImagesSrc.push({
                key: newThumbnailImgPut.key,
                src: thumbnailImgSrc,
              });

              this.editedItem.searchField = JSON.stringify(
                _.values(
                  _.omit(this.editedItem, this.productSearchExcludeFields),
                ),
              ).toLowerCase();

              await DataStore.save(
                Product.copyOf(
                  _.find(this.unfilteredProductsArray, {
                    id: this.editedItem.id,
                  }),
                  (product) => {
                    product.thumbnails = this.editedItem.thumbnails;
                    product.searchField = this.editedItem.searchField;
                  },
                ),
              )
                .catch((err) => {
                  console.error("DataStore save error:", err);
                  throw err;
                })
                .then(() => {
                  this.unEditedProduct.thumbnails = _.cloneDeep(
                    this.editedItem.thumbnails,
                  );
                  this.unEditedProduct.searchField =
                    this.editedItem.searchField;
                });
            }

            this.loading = false;
          }
        });

        document.body.appendChild(inputElement);
        inputElement.click();
        document.body.removeChild(inputElement); // Clean up after click
      } catch (error) {
        console.error("Upload error:", error);
        this.loading = false;
      }
    },

    async uploadProductContent() {
      try {
        if (!this.productContentDatamodel) {
          // Create ProductContent if it doesn't exist
          const newProductContent = await DataStore.save(
            new ProductContent({
              productId: this.editedItem.id,
            }),
          );
          this.productContentDatamodel = newProductContent;

          //// CHECK
          this.productContentProductId = this.editedItem.id;
        }

        const inputElement = document.createElement("input");
        inputElement.type = "file";
        // inputElement.accept = "image/*";
        inputElement.multiple = true; // Allow multiple files to be selected

        inputElement.addEventListener("change", async (event) => {
          if (
            event.target instanceof HTMLInputElement &&
            event.target.files &&
            event.target.files.length > 0
          ) {
            this.loading = true;
            // const files = event.target.files;
            const files = Array.from(event.target.files); // Convert FileList to array

            // console.log("files", files);

            // return objects of file's name and percentageDownloaded = 0
            this.uploadingFiles = files.map((file) => ({
              name: file.name,
              percentageUploaded: 0,
            }));

            // console.log("this.uploadingFiles", this.uploadingFiles);

            let newProductContentKeyArray = [];

            for (let i = 0; i < files.length; i++) {
              const file = files[i];

              const newKey =
                "ProductsContent/" +
                this.productContentDatamodel.id +
                "/" +
                Date.now() +
                "-" +
                file.name;

              // console.log("newKey", newKey);

              // newProductContentKeyArray.push(newKey);

              await Storage.put(newKey, file, {
                progressCallback: (progress) => {
                  // console.log(`Uploaded: ${progress.loaded}/${progress.total}`);

                  // Update the percentageUploaded for the current file
                  const percentageUploaded = Math.round(
                    (progress.loaded / progress.total) * 100,
                  );
                  this.$set(this.uploadingFiles, i, {
                    ...this.uploadingFiles[i],
                    percentageUploaded,
                  });
                },
              })
                .catch((err) => console.log(err))
                .then(() =>
                  // response
                  {
                    // console.log(response);
                    newProductContentKeyArray.push(newKey);
                  },
                );
            }

            if (newProductContentKeyArray.length > 0) {
              const newFileKeys = [
                ...new Set([
                  ...(this.productContentFileKeys || []),
                  ...newProductContentKeyArray,
                ]),
              ];

              // Update ProductContent fileKeys
              await DataStore.save(
                ProductContent.copyOf(
                  this.productContentDatamodel,
                  (productContent) => {
                    productContent.fileKeys = newFileKeys;
                  },
                ),
              ).catch((err) => console.log(err));
            }

            this.loading = false;
          }
        });

        document.body.appendChild(inputElement);
        inputElement.click();
      } catch (error) {
        console.log(error);

        this.loading = false;
      } finally {
        this.getProductContent();
      }
    },

    resetForm() {
      if (this.$refs.form) this.$refs.form.reset();
      this.editedItem = _.cloneDeep(this.defaultItem);

      this.editedAddons = [];
      this.unEditedAddons = [];

      this.editedRecommendations = [];
      this.unEditedRecommendations = [];

      this.valid = false;
    },

    manageProductTags() {
      this.dialogManageProductTags = true;
    },

    createProductTag() {
      this.valid = false;
      this.dialogEditProductTag = true;
    },

    editProductTag(item, index) {
      this.editedProductTagIndex = index;
      this.editedProductTagItem = _.cloneDeep(item);
      this.dialogEditProductTag = true;
    },

    async saveProductTag() {
      this.loading = true;
      try {
        if (this.editedProductTagIndex === -1) {
          await DataStore.save(
            new ProductTag({
              name: this.editedProductTagItem.name.trim(),
            }),
          );
        } else {
          await DataStore.save(
            ProductTag.copyOf(
              _.find(this.syncedProductTagArray, {
                id: this.editedProductTagItem.id,
              }),
              (updateModel) => {
                updateModel.name = this.editedProductTagItem.name.trim();
              },
            ),
          );
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.closeEditProductTag();
      }
    },

    deleteProductTag(item) {
      this.editedProductTagIndex = this.syncedProductTagArray.indexOf(item);
      this.dialogDeleteProductTag = true;
    },

    async deleteProductTagConfirm() {
      this.deletingItem = true;
      try {
        await DataStore.delete(
          this.syncedProductTagArray[this.editedProductTagIndex],
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.deletingItem = false;
        this.closeDeleteProductTag();
      }
    },

    manageProductCategories() {
      this.dialogManageProductCategories = true;
    },

    createProductCategory() {
      this.valid = false;
      this.dialogEditProductCategory = true;
    },

    editProductCategory(item, index) {
      this.editedProductCategoryIndex = index;
      this.editedProductCategoryItem = _.cloneDeep(item);
      this.dialogEditProductCategory = true;
    },

    async saveProductCategory() {
      this.loading = true;
      try {
        if (this.editedProductCategoryIndex === -1) {
          await DataStore.save(
            new ProductCategory({
              name: this.editedProductCategoryItem.name.trim(),
              slug: this.editedProductCategoryItem.slug.trim(),
              grade: this.editedProductCategoryItem.grade || null,
              parentId: this.editedProductCategoryItem.parentId,
            }),
          );
        } else {
          await DataStore.save(
            ProductCategory.copyOf(
              _.find(this.syncedProductCategoryArray, {
                id: this.editedProductCategoryItem.id,
              }),
              (updateModel) => {
                (updateModel.name = this.editedProductCategoryItem.name.trim()),
                  (updateModel.slug =
                    this.editedProductCategoryItem.slug.trim()),
                  (updateModel.grade =
                    this.editedProductCategoryItem.grade || null),
                  (updateModel.parentId =
                    this.editedProductCategoryItem.parentId);
              },
            ),
          );
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.closeEditProductCategory();
      }
    },

    deleteProductCategory(item) {
      this.editedProductCategoryIndex =
        this.syncedProductCategoryArray.indexOf(item);
      this.dialogDeleteProductCategory = true;
    },

    async deleteProductCategoryConfirm() {
      this.deletingItem = true;
      try {
        await DataStore.delete(
          this.syncedProductCategoryArray[this.editedProductCategoryIndex],
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.deletingItem = false;
        this.closeDeleteProductCategory();
      }
    },

    createItem() {
      this.resetForm();
      this.editedItem.publishDate = new Date().toISOString();

      this.productPublishDate = this.editedItem.publishDate.substring(0, 10);
      this.productPublishTime = new Date(
        new Date(this.editedItem.publishDate).getTime() + 2 * 60 * 60 * 1000,
      )
        .toISOString()
        .substring(11, 16);
      this.dialog = true;
    },

    async duplicateItem(item) {
      try {
        this.loading = true;

        const dupEditedItem = _.cloneDeep(item);

        dupEditedItem.thumbnails = [];

        dupEditedItem.recommendations = item.recommendations
          ? _.cloneDeep(item.recommendations)
          : null;

        dupEditedItem.searchField = JSON.stringify(
          _.values(_.omit(dupEditedItem, this.productSearchExcludeFields)),
        ).toLowerCase();

        const newProduct = await DataStore.save(
          new Product({
            title: dupEditedItem.title.trim() + " - COPY",
            description: dupEditedItem.description
              ? dupEditedItem.description.trim()
              : "",
            price:
              typeof dupEditedItem.price === "string"
                ? parseFloat(dupEditedItem.price)
                : dupEditedItem.price,
            discountPercentage:
              typeof dupEditedItem.discountPercentage === "string"
                ? parseFloat(dupEditedItem.discountPercentage)
                : dupEditedItem.discountPercentage,
            thumbnails: [],
            tags: dupEditedItem.tags?.length > 0 ? dupEditedItem.tags : [],
            questions: dupEditedItem.questions,
            publishDate: dupEditedItem.publishDate,
            featured: dupEditedItem.featured,
            physical: dupEditedItem.physical,
            subscriptionProduct: dupEditedItem.subscriptionProduct,
            eCommerceProduct: dupEditedItem.eCommerceProduct,
            searchField: dupEditedItem.searchField,
            sku: dupEditedItem.sku ? dupEditedItem.sku.trim() : null,
            categoryId: dupEditedItem.categoryId,
            subjectID: dupEditedItem.subjectID || null,
            videoPreview:
              dupEditedItem.videoPreview > ""
                ? dupEditedItem.videoPreview
                : null,
            recommendations: dupEditedItem.recommendations,
            type: "Product",
          }),
        );

        // this.productContentProductId = newProduct.id;
        // console.log(
        //   "this.productContentProductId",
        //   this.productContentProductId
        // );

        const currentProductContentItem = this.syncedProductContentArray.find(
          (item) => item.productId === dupEditedItem.id,
        );

        if (currentProductContentItem) {
          const newProductContentDup = await DataStore.save(
            new ProductContent({
              productId: newProduct.id,
              urls:
                currentProductContentItem.urls?.length > 0
                  ? currentProductContentItem.urls
                  : [],
            }),
          );

          if (currentProductContentItem.fileKeys?.length > 0) {
            // for (const fileKey of currentProductContentItem.fileKeys) {
            //   await Storage.remove(fileKey, {
            //     level: "public",
            //   });
            // }
            let duplicatedFileKeys = []; // Initialize the array here
            await Promise.all(
              currentProductContentItem.fileKeys.map(async (fileKey) => {
                const newFileKey =
                  "ProductsContent/" +
                  newProductContentDup.id +
                  "/" +
                  fileKey.split("/").pop();

                const copiedFile = await Storage.copy(
                  { key: fileKey },
                  { key: newFileKey },
                );

                duplicatedFileKeys.push(copiedFile.key);
              }),
            );

            await DataStore.save(
              ProductContent.copyOf(newProductContentDup, (updateModel) => {
                updateModel.fileKeys = duplicatedFileKeys;
              }),
            );
          }
        } else {
          await DataStore.save(
            new ProductContent({
              productId: newProduct.id,
            }),
          );
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async editItem(item) {
      // console.log("editItem:", item);
      this.productContentProductId = item.id;

      this.getProductContent();

      this.editedIndex = this.unfilteredProductsArray.findIndex(
        (obj) => obj.id === item.id,
      );

      this.editedItem = _.cloneDeep(item);

      const pAddons = item.addons || [];
      const cAddons = this.productContentDatamodel.addons || [];
      this.editedAddons = pAddons.map((pa) => {
        const ca = cAddons.find(
          (ca) => ca.type === pa.type && ca.title === pa.title,
        ) || { fileKey: null, url: null };
        return {
          type: pa.type,
          title: pa.title,
          price: typeof pa.price === "string" ? parseFloat(pa.price) : pa.price,
          fileKey: ca.fileKey,
          url: ca.url,
        };
      });
      this.unEditedAddons = _.cloneDeep(this.editedAddons);

      if (item.thumbnails) {
        item.thumbnails.forEach(async (thumbnailKey) => {
          if (!_.find(this.thumbnailImagesSrc, { key: thumbnailKey })) {
            const thumbnailImgSrc = await this.getThumbnailImage(thumbnailKey);
            this.thumbnailImagesSrc.push({
              key: thumbnailKey,
              src: thumbnailImgSrc,
            });
          }
        });
      }
      if (item.publishDate) {
        this.productPublishDate = item.publishDate.substring(0, 10);
        this.productPublishTime = new Date(
          new Date(item.publishDate).getTime() + 2 * 60 * 60 * 1000,
        )
          .toISOString()
          .substring(11, 16);
      }

      this.editedRecommendations = _.cloneDeep(item.recommendations || []);
      this.unEditedRecommendations = _.cloneDeep(this.editedRecommendations);

      this.unEditedProduct = _.cloneDeep(this.editedItem);
      this.dialog = true;
    },

    deleteItem(item) {
      const itemToDelete = this.unfilteredProductsArray.find(
        (product) => product.id === item.id,
      );
      if (!itemToDelete) return;
      this.editedIndex = this.unfilteredProductsArray.findIndex(
        (obj) => obj.id === item.id,
      );
      this.editedItem = _.cloneDeep(item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.deletingItem = true;
      try {
        // this.products.splice(this.editedIndex, 1);
        await DataStore.delete(this.unfilteredProductsArray[this.editedIndex]);

        for (const thumbnailKey of this.editedItem.thumbnails) {
          await Storage.remove(thumbnailKey, {
            level: "public",
          });
        }

        await DataStore.query(ProductContent, (c) =>
          c.productId("eq", this.editedItem.id),
        ).then(async (productContent) => {
          if (productContent.length > 0) {
            if (productContent[0].fileKeys?.length > 0) {
              for (const fileKey of productContent[0].fileKeys) {
                await Storage.remove(fileKey, {
                  level: "public",
                }).catch((err) => console.log(err));
              }
            }

            if (productContent[0].addons?.length > 0) {
              for (const addon of productContent[0].addons) {
                if (addon.fileKey) {
                  await Storage.remove(addon.fileKey, {
                    level: "public",
                  }).catch((err) => console.log(err));
                }
              }
            }

            await DataStore.delete(productContent[0]);
          }
        });
      } catch (error) {
        console.log(error);
      }

      this.deletingItem = false;
      this.closeDelete();
    },

    async toggleSoftDeleteProduct(product) {
      try {
        const confirmAction = product.softDeleted
          ? "Are you sure you want to restore this product? It will become visible to users."
          : "Are you sure you want to soft delete this product? It will be hidden from all users.";

        if (!confirm(confirmAction)) {
          return;
        }

        this.loading = true;

        // Get the source object from unfilteredProductsArray (ensures valid model)
        const sourceProduct = _.find(this.unfilteredProductsArray, {
          id: product.id,
        });

        if (!sourceProduct) {
          console.error("Product not found in unfilteredProductsArray");
          this.loading = false;
          return;
        }

        // Soft delete/restore the product
        const updatedProduct = await DataStore.save(
          Product.copyOf(sourceProduct, (updated) => {
            updated.softDeleted = !product.softDeleted;
          }),
        );

        // Update the local products array
        const index = this.products.findIndex(
          (p) => p.id === updatedProduct.id,
        );
        if (index !== -1) {
          this.$set(this.products, index, updatedProduct);
        }

        console.log(
          product.softDeleted
            ? "Product restored successfully"
            : "Product soft deleted successfully",
        );

        // Refresh the query to update the table immediately
        await this.changeProductsSearchQuery();
      } catch (error) {
        console.error("Error toggling soft delete:", error);
      } finally {
        this.loading = false;
      }
    },

    async cancel() {
      this.cancelingChanges = true;

      try {
        this.thumbnailImagesSrc.forEach(async (thumbnailImgSrc) => {
          const thumbnailKey = thumbnailImgSrc.key;

          if (!this.unEditedProduct.thumbnails.includes(thumbnailKey)) {
            _.remove(this.thumbnailImagesSrc, { key: thumbnailKey });

            await Storage.remove(thumbnailKey, {
              level: "public",
            });
          }
        });

        if (this.unEditedProduct.thumbnails) {
          this.unEditedProduct.thumbnails.forEach(async (thumbnailKey) => {
            if (!_.find(this.thumbnailImagesSrc, { key: thumbnailKey })) {
              const thumbnailImgSrc = await this.getThumbnailImage(
                thumbnailKey,
              );
              this.thumbnailImagesSrc.push({
                key: thumbnailKey,
                src: thumbnailImgSrc,
              });
            }
          });
        }

        this.editedItem = _.cloneDeep(this.unEditedProduct);

        this.editedRecommendations = _.cloneDeep(this.unEditedRecommendations);

        // if (
        //   !this.editedItem.physical &&
        //   this.editedItem.questions?.length > 0
        // ) {
        //   this.editedItem.questions = [];
        // }

        if (this.editedItem.questions?.length > 0) {
          this.editedItem.questions.forEach((question) => {
            if (
              question.type !== "Select" &&
              question.type !== "Multi Select" &&
              question.type !== "Radio" &&
              question.type !== "Checkbox"
            ) {
              question.items = [];
            }
          });
        }

        this.productContentUrls =
          this.productContentDatamodel?.urls?.length > 0
            ? _.cloneDeep(this.productContentDatamodel.urls)
            : [];

        const unEditedAddonFileKeys = this.unEditedAddons
          .map((a) => a.fileKey)
          .filter(Boolean);

        const currentAddonFileKeys = this.editedAddons
          .map((a) => a.fileKey)
          .filter(Boolean);

        const addonFilesToDelete = currentAddonFileKeys.filter(
          (k) => !unEditedAddonFileKeys.includes(k),
        );

        addonFilesToDelete.forEach(async (k) => {
          await Storage.remove(k).catch((err) => console.log(err));
        });

        this.editedAddons = _.cloneDeep(this.unEditedAddons);

        const contentAddons = this.editedAddons.map((a) => ({
          type: a.type.trim(),
          title: a.title.trim(),
          fileKey: a.fileKey || null,
          url: a.url ? a.url.trim() : null,
        }));

        const productAddons = this.editedAddons.map((a) => ({
          type: a.type.trim(),
          title: a.title.trim(),
          price: typeof a.price === "string" ? parseFloat(a.price) : a.price,
        }));

        this.editedItem.searchField = JSON.stringify(
          _.values(_.omit(this.editedItem, this.productSearchExcludeFields)),
        ).toLowerCase();

        await DataStore.save(
          Product.copyOf(
            _.find(this.unfilteredProductsArray, { id: this.editedItem.id }),
            (updateModel) => {
              (updateModel.title = this.editedItem.title.trim()),
                (updateModel.description = this.editedItem.description
                  ? this.editedItem.description.trim()
                  : ""),
                (updateModel.price =
                  typeof this.editedItem.price === "string"
                    ? parseFloat(this.editedItem.price)
                    : this.editedItem.price),
                (updateModel.discountPercentage =
                  typeof this.editedItem.discountPercentage === "string"
                    ? parseFloat(this.editedItem.discountPercentage)
                    : this.editedItem.discountPercentage),
                (updateModel.thumbnails = this.editedItem.thumbnails),
                (updateModel.tags =
                  this.editedItem.tags?.length > 0 ? this.editedItem.tags : []),
                (updateModel.questions = this.editedItem.questions),
                (updateModel.publishDate = this.editedItem.publishDate),
                (updateModel.featured = this.editedItem.featured),
                (updateModel.physical = this.editedItem.physical),
                (updateModel.subscriptionProduct =
                  this.editedItem.subscriptionProduct),
                (updateModel.eCommerceProduct =
                  this.editedItem.eCommerceProduct),
                (updateModel.searchField = this.editedItem.searchField),
                (updateModel.categoryId = this.editedItem.categoryId),
                (updateModel.subjectID = this.editedItem.subjectID || null),
                (updateModel.videoPreview =
                  this.editedItem.videoPreview > ""
                    ? this.editedItem.videoPreview
                    : null),
                (updateModel.addons =
                  productAddons.length === 0 ? null : productAddons),
                (updateModel.recommendations =
                  this.editedRecommendations.length === 0
                    ? null
                    : this.editedRecommendations);
            },
          ),
        );
      } catch (error) {
        console.log(error);
      }

      this.$nextTick(() => {
        this.dialogCancel = false;
        this.cancelingChanges = false;
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = _.cloneDeep(this.defaultItem);
        this.editedIndex = -1;
        this.thumbnailImagesSrc = _.cloneDeep([]);
        this.productPublishDate = "";
        this.productPublishTime = "";
        this.unEditedProduct = {};
        this.productContentDatamodel = null;
        this.productContentFileKeys = [];
        this.productContentUrls = [];
        this.productContentProductId = "";
        this.uploadingFiles = [];

        this.editedAddons = [];
        this.unEditedAddons = [];

        this.editedRecommendations = [];
        this.unEditedRecommendations = [];
        // this.syncedProductContentArray = [];
      });
    },

    closeManageProductTags() {
      this.dialogManageProductTags = false;
    },

    closeDeleteProductTag() {
      this.dialogDeleteProductTag = false;
      this.$nextTick(() => {
        this.editedProductTagIndex = -1;
      });
    },

    closeEditProductTag() {
      this.dialogEditProductTag = false;
      this.$nextTick(() => {
        this.editedProductTagItem = _.cloneDeep(this.defaultProductTagItem);
        this.editedProductTagIndex = -1;
      });
    },

    closeManageProductCategories() {
      this.dialogManageProductCategories = false;
    },

    closeDeleteProductCategory() {
      this.dialogDeleteProductCategory = false;
      this.$nextTick(() => {
        this.editedProductCategoryIndex = -1;
      });
    },

    closeEditProductCategory() {
      this.dialogEditProductCategory = false;
      this.$nextTick(() => {
        this.editedProductCategoryItem = _.cloneDeep(
          this.defaultProductCategoryItem,
        );
        this.editedProductCategoryIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = _.cloneDeep(this.defaultItem);
        this.editedIndex = -1;
        this.thumbnailImagesSrc = _.cloneDeep([]);
        this.productPublishDate = "";
        this.productPublishTime = "";
        this.productContentDatamodel = null;
        this.productContentFileKeys = [];
        this.productContentUrls = [];
        this.productContentProductId = "";
        // this.syncedProductContentArray = [];
      });
    },

    closeProductContentVerify() {
      this.dialogProductContentVerify = false;
      // this.$nextTick(() => {
      //   this.failedProductsContent = [];
      // });
    },

    closeCancel() {
      this.dialogCancel = false;
    },

    async save() {
      this.loading = true;
      if (this.editedIndex > -1) {
        // Update schedule
        await this.updateProduct();
      } else {
        // Create new schedule
        await this.createProduct();
      }

      this.unEditedProduct = _.cloneDeep(this.editedItem);

      await this.syncProductToMailchimp(this.editedItem); //Production Only

      this.unEditedAddons = _.cloneDeep(this.editedAddons);
      this.unEditedRecommendations = _.cloneDeep(this.editedRecommendations);

      this.$nextTick(() => {
        this.loading = false;
      });
    },

    async createProduct() {
      try {
        // if (
        //   !this.editedItem.physical &&
        //   this.editedItem.questions?.length > 0
        // ) {
        //   this.editedItem.questions = [];
        // }

        if (this.editedItem.questions?.length > 0) {
          this.editedItem.questions.forEach((question) => {
            if (
              question.type !== "Select" &&
              question.type !== "Multi Select" &&
              question.type !== "Radio" &&
              question.type !== "Checkbox"
            ) {
              question.items = [];
            }
          });
        }

        // Set searchField
        this.editedItem.searchField = JSON.stringify(
          _.values(_.omit(this.editedItem, this.productSearchExcludeFields)),
        ).toLowerCase();

        // Create new Product
        const newProduct = await DataStore.save(
          new Product({
            title: this.editedItem.title.trim(),
            description: this.editedItem.description
              ? this.editedItem.description.trim()
              : "",
            price:
              typeof this.editedItem.price === "string"
                ? parseFloat(this.editedItem.price)
                : this.editedItem.price,
            discountPercentage:
              typeof this.editedItem.discountPercentage === "string"
                ? parseFloat(this.editedItem.discountPercentage)
                : this.editedItem.discountPercentage,
            thumbnails: [],
            tags: this.editedItem.tags?.length > 0 ? this.editedItem.tags : [],
            questions: this.editedItem.questions,
            publishDate: this.editedItem.publishDate,
            featured: this.editedItem.featured,
            physical: this.editedItem.physical,
            subscriptionProduct: this.editedItem.subscriptionProduct,
            eCommerceProduct: this.editedItem.eCommerceProduct,
            searchField: this.editedItem.searchField,
            sku: this.editedItem.sku ? this.editedItem.sku.trim() : null,
            categoryId: this.editedItem.categoryId,
            subjectID: this.editedItem.subjectID || null,
            videoPreview:
              this.editedItem.videoPreview > ""
                ? this.editedItem.videoPreview
                : null,
            recommendations:
              this.editedRecommendations.length > 0
                ? this.editedRecommendations
                : null,
            type: "Product",
          }),
        );

        this.editedRecommendations = _.cloneDeep(
          newProduct.recommendations || [],
        );

        for (const rec of this.editedRecommendations) {
          await this.updateReciprocalRecommendation(newProduct.id, rec);
        }

        // Create ProductContent
        const newProductContentObj = await DataStore.save(
          new ProductContent({
            productId: newProduct.id,
          }),
        );

        const productCategory =
          this.syncedProductCategoryArray.find(
            (cat) => cat.id === this.editedItem.categoryId,
          ) || null;

        // Generate seoId
        const seoId = `product/${this.generateSeoId(
          this.editedItem.title,
          productCategory,
        )}`;
        if (!seoId) {
          console.warn("Failed to generate seoId for product:", newProduct.id);
        } else {
          // Prepare ProductSEO properties
          const redirectProps = {
            seoId,
            Product: newProduct,
          };

          // Create ProductSEO
          await DataStore.save(new ProductSEO(redirectProps)).catch((err) => {
            console.error("Error creating ProductSEO:", err);
          });
        }

        // Update component state
        this.productContentProductId = newProduct.id;
        this.editedItem.id = newProduct.id;
        this.editedIndex = 0;
        this.getProductContent(newProductContentObj);
      } catch (error) {
        console.error("Error creating product:", error);
      }
    },

    async updateProduct() {
      try {
        // Update ProductContent URLs if changed
        let contentEqual = true;
        if (this.productContentDatamodel?.urls?.length > 0) {
          contentEqual =
            _.isEqual(
              this.productContentUrls,
              this.productContentDatamodel.urls,
            ) || _.isEqual(this.editedAddons, this.unEditedAddons);
        } else {
          contentEqual = false;
        }

        if (!contentEqual) {
          const contentAddons = this.editedAddons.map((a) => ({
            type: a.type.trim(),
            title: a.title.trim(),
            fileKey: a.fileKey || null,
            url: a.url ? a.url.trim() : null,
          }));

          if (!this.productContentDatamodel) {
            // Create ProductContent if it doesn't exist
            const newProductContentObj = await DataStore.save(
              new ProductContent({
                productId: this.editedItem.id,
                urls:
                  this.productContentUrls.length === 0
                    ? null
                    : this.productContentUrls,
                addons: contentAddons.length === 0 ? null : contentAddons,
              }),
            );
            this.productContentDatamodel = newProductContentObj;

            // // CHECK
            this.productContentProductId = this.editedItem.id;
            this.getProductContent(newProductContentObj);
          } else {
            await DataStore.save(
              ProductContent.copyOf(this.productContentDatamodel, (c) => {
                c.urls =
                  this.productContentUrls.length === 0
                    ? null
                    : this.productContentUrls;
                c.addons = contentAddons.length === 0 ? null : contentAddons;
              }),
            );
          }
        }

        // Update Product if changed
        if (
          !_.isEqual(this.editedItem, this.unEditedProduct) ||
          !_.isEqual(this.editedAddons, this.unEditedAddons) ||
          !_.isEqual(this.editedRecommendations, this.unEditedRecommendations)
        ) {
          // if (
          //   !this.editedItem.physical &&
          //   this.editedItem.questions?.length > 0
          // ) {
          //   this.editedItem.questions = [];
          // }

          if (this.editedItem.questions?.length > 0) {
            this.editedItem.questions.forEach((question) => {
              if (
                question.type !== "Select" &&
                question.type !== "Multi Select" &&
                question.type !== "Radio" &&
                question.type !== "Checkbox"
              ) {
                question.items = [];
              }
            });
          }

          const unEditedFileKeys = this.unEditedAddons
            .map((a) => a.fileKey)
            .filter(Boolean);
          const editedFileKeys = this.editedAddons
            .map((a) => a.fileKey)
            .filter(Boolean);
          const filesToDelete = unEditedFileKeys.filter(
            (k) => !editedFileKeys.includes(k),
          );
          for (const fileKey of filesToDelete) {
            await Storage.remove(fileKey, { level: "public" }).catch((err) =>
              console.log(err),
            );
          }

          const productAddons = this.editedAddons.map((a) => ({
            type: a.type.trim(),
            title: a.title.trim(),
            price: typeof a.price === "string" ? parseFloat(a.price) : a.price,
          }));

          this.editedItem.searchField = JSON.stringify(
            _.values(_.omit(this.editedItem, this.productSearchExcludeFields)),
          ).toLowerCase();

          const updatedProduct = await DataStore.save(
            Product.copyOf(
              _.find(this.unfilteredProductsArray, { id: this.editedItem.id }),
              (updateModel) => {
                updateModel.title = this.editedItem.title.trim();
                updateModel.description = this.editedItem.description
                  ? this.editedItem.description.trim()
                  : "";
                updateModel.price =
                  typeof this.editedItem.price === "string"
                    ? parseFloat(this.editedItem.price)
                    : this.editedItem.price;
                updateModel.discountPercentage =
                  typeof this.editedItem.discountPercentage === "string"
                    ? parseFloat(this.editedItem.discountPercentage)
                    : this.editedItem.discountPercentage;
                updateModel.thumbnails = this.editedItem.thumbnails;
                updateModel.tags =
                  this.editedItem.tags?.length > 0 ? this.editedItem.tags : [];
                updateModel.questions = this.editedItem.questions;
                updateModel.publishDate = this.editedItem.publishDate;
                updateModel.featured = this.editedItem.featured;
                updateModel.physical = this.editedItem.physical;
                updateModel.subscriptionProduct =
                  this.editedItem.subscriptionProduct;
                updateModel.eCommerceProduct = this.editedItem.eCommerceProduct;
                updateModel.searchField = this.editedItem.searchField;
                updateModel.sku = this.editedItem.sku
                  ? this.editedItem.sku.trim()
                  : null;
                updateModel.categoryId = this.editedItem.categoryId;
                updateModel.subjectID = this.editedItem.subjectID || null;
                updateModel.videoPreview =
                  this.editedItem.videoPreview > ""
                    ? this.editedItem.videoPreview
                    : null;
                updateModel.addons =
                  productAddons.length === 0 ? null : productAddons;
                updateModel.recommendations =
                  this.editedRecommendations.length > 0
                    ? this.editedRecommendations
                    : null;
              },
            ),
          );

          this.editedRecommendations = _.cloneDeep(
            updatedProduct.recommendations || [],
          );

          const addedRecommendations = this.editedRecommendations.filter(
            (rec) =>
              !this.unEditedRecommendations.some(
                (u) => u.productId === rec.productId,
              ),
          );
          for (const rec of addedRecommendations) {
            await this.updateReciprocalRecommendation(updatedProduct.id, rec);
          }

          const productCategory =
            this.syncedProductCategoryArray.find(
              (cat) => cat.id === this.editedItem.categoryId,
            ) || null;

          // Handle ProductSEO
          const seoId = `product/${this.generateSeoId(
            this.editedItem.title,
            productCategory,
          )}`;
          if (!seoId) {
            console.warn(
              "Failed to generate seoId for product:",
              this.editedItem.id,
            );
          } else {
            // If the title changed, we leave the old ProductSEO untouched and
            // create a brand new one with the new seoId (so the old link still resolves).
            const titleChanged =
              (this.unEditedProduct.title || "").trim() !==
              (this.editedItem.title || "").trim();

            // Check if ProductSEO exists
            const existingProductSEO =
              this.syncedProductSEOArray.find(
                (seo) => seo.productID === this.editedItem.id,
              ) || null;

            console.log("existingProductSEO", existingProductSEO);
            console.log("titleChanged", titleChanged);

            const redirectProps = {
              seoId,
              Product: updatedProduct,
            };

            console.log("redirectProps", redirectProps);

            if (existingProductSEO && !titleChanged) {
              // Title unchanged -> keep the existing ProductSEO in sync.
              await DataStore.save(
                ProductSEO.copyOf(existingProductSEO, (updated) => {
                  updated.seoId = seoId;
                  updated.Product = redirectProps.Product;
                }),
              ).catch((err) => {
                console.error("Error updating ProductSEO:", err);
              });
            } else {
              // Title changed (or no SEO existed yet) -> create a NEW ProductSEO
              // and leave any existing/older ProductSEO records untouched.
              await DataStore.save(new ProductSEO(redirectProps)).catch(
                (err) => {
                  console.error("Error creating ProductSEO:", err);
                },
              );
            }
          }
        }
      } catch (error) {
        console.error("Error updating product:", error);
      }
    },

    getProductContent(productContentDMProp) {
      try {
        this.loading = true;

        if (productContentDMProp) {
          this.productContentDatamodel = productContentDMProp;
          this.productContentFileKeys =
            productContentDMProp.fileKeys?.length > 0
              ? _.cloneDeep(productContentDMProp.fileKeys)
              : [];

          let productContentUrlsArray =
            productContentDMProp.urls?.length > 0
              ? _.cloneDeep(productContentDMProp.urls)
              : [];

          this.productContentUrls = productContentUrlsArray;
        } else if (this.productContentProductId !== "") {
          const currentProductContentItem = this.syncedProductContentArray.find(
            (item) => item.productId === this.productContentProductId,
          );

          if (currentProductContentItem) {
            const productContentModel = currentProductContentItem;
            this.productContentDatamodel = productContentModel;
            this.productContentFileKeys =
              productContentModel.fileKeys?.length > 0
                ? _.cloneDeep(productContentModel.fileKeys)
                : [];

            let productContentUrlsArray =
              productContentModel.urls?.length > 0
                ? _.cloneDeep(productContentModel.urls)
                : [];

            this.productContentUrls = productContentUrlsArray;
          }
        }

        console.log(
          "this.productContentDatamodel updated:",
          this.productContentDatamodel,
        );
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async queryProducts() {
      try {
        const search = this.productsDataTableSearch.split(" ");
        this.selectedProducts = [];

        const searchMissingProductContentProductIds =
          this.failedProductsContent.map((product) => product.id);

        const productCount = (
          await DataStore.query(Product, (product) =>
            product.and((f) => [
              this.productsDataTableSearchTags.every((tag) =>
                f.tags("contains", tag),
              ),
              f.or((f) =>
                this.productsDataTableSearchCategories.reduce(
                  (c, id) => c.categoryId("eq", id),
                  f,
                ),
              ),
              this.productsDataTableSearchSubjects.length > 0
                ? f.or((o) =>
                    this.productsDataTableSearchSubjects.map((subjectID) =>
                      subjectID === NO_SUBJECT
                        ? o.subjectID("eq", null)
                        : o.subjectID("eq", subjectID),
                    ),
                  )
                : f,
              this.searchMissingProductContent
                ? f.or((f) =>
                    searchMissingProductContentProductIds.reduce(
                      (c, id) => c.id("eq", id),
                      f,
                    ),
                  )
                : f,
              search
                .map((str) => str.toLowerCase())
                .every((string) =>
                  f.or((o) => [
                    o.searchField("contains", string),
                    o.id("eq", string), // ← added
                    // o.id("contains", string)   // alternative if you want partial ID match
                  ]),
                ),

              this.searchECommerceProduct ? f.eCommerceProduct("eq", true) : f,
              this.searchPhysicalProduct ? f.physical("eq", true) : f,
              this.searchSubscriptionProduct
                ? f.subscriptionProduct("eq", true)
                : f,
              this.showOnlySoftDeleted
                ? f.softDeleted("eq", true)
                : f.softDeleted("ne", true),
            ]),
          )
        ).length;

        this.productsDataTableServerItemsLength = productCount || 0;

        const filterObj = {
          page: this.productsDataTablePageCount - 1,
          limit: this.productsDataTableRowsPerPage,
          sort: (s) =>
            s[this.sortBy](
              this.sortDesc
                ? SortDirection.DESCENDING
                : SortDirection.ASCENDING,
            ),
        };

        if (this.productsDataTableRowsPerPage === -1) {
          delete filterObj.page;
          delete filterObj.limit;
        }

        const queriedProducts = await DataStore.query(
          Product,
          (product) =>
            product.and((f) => [
              this.productsDataTableSearchTags.every((tag) =>
                f.tags("contains", tag),
              ),
              f.or((f) =>
                this.productsDataTableSearchCategories.reduce(
                  (c, id) => c.categoryId("eq", id),
                  f,
                ),
              ),
              this.productsDataTableSearchSubjects.length > 0
                ? f.or((o) =>
                    this.productsDataTableSearchSubjects.map((subjectID) =>
                      subjectID === NO_SUBJECT
                        ? o.subjectID("eq", null)
                        : o.subjectID("eq", subjectID),
                    ),
                  )
                : f,
              this.searchMissingProductContent
                ? f.or((f) =>
                    searchMissingProductContentProductIds.reduce(
                      (c, id) => c.id("eq", id),
                      f,
                    ),
                  )
                : f,
              search
                .map((str) => str.toLowerCase())
                .every((string) =>
                  f.or((o) => [
                    o.searchField("contains", string),
                    o.id("eq", string), // ← added
                    // o.id("contains", string)   // alternative if you want partial ID match
                  ]),
                ),

              this.searchECommerceProduct ? f.eCommerceProduct("eq", true) : f,
              this.searchPhysicalProduct ? f.physical("eq", true) : f,
              this.searchSubscriptionProduct
                ? f.subscriptionProduct("eq", true)
                : f,
              this.showOnlySoftDeleted
                ? f.softDeleted("eq", true)
                : f.softDeleted("ne", true),
            ]),
          filterObj,
        );

        this.syncedProductArray = queriedProducts;

        // this.products = _.cloneDeep(products);

        // Loop through queriedProducts to update or add new products
        queriedProducts.forEach((newProduct) => {
          // console.log("newProduct:", newProduct);
          const existingProductIndex = this.products.findIndex(
            (product) => product.id === newProduct.id,
          );
          // console.log("existingProductIndex:", existingProductIndex);

          if (existingProductIndex !== -1) {
            const existingProduct = this.products[existingProductIndex];

            if (existingProduct.updatedAt !== newProduct.updatedAt) {
              // Update the product while preserving thumbnailImages
              const updatedProduct = {
                ...newProduct,
                thumbnailImages: existingProduct.thumbnailImages,
              };
              this.products.splice(existingProductIndex, 1, updatedProduct);
            }
          } else {
            // If new product doesn't exist in this.products, add it
            this.products.push({
              ...newProduct,
              thumbnailImages: [],
            });
          }
        });

        // // Remove products not in sortedProducts
        this.products = this.products.filter((product) =>
          queriedProducts.some((newProduct) => newProduct.id === product.id),
        );

        this.products = _.sortBy(this.products, [
          (p) => p.featured || false,
          (p) => new Date(p.publishDate),
          (p) => p.title,
        ]).reverse();
      } catch (error) {
        console.log(error);
      }
    },

    syncData() {
      // console.log("Syncing data...ADMINPRODUCTS");

      try {
        this.syncProducts();
        this.syncProductBundles();

        const redirectSubscription = DataStore.observeQuery(Redirect).subscribe(
          async (snapshot) => {
            const { isSynced, items } = snapshot;
            if (isSynced && !_.isEqual(items, this.syncedRedirectArray)) {
              this.syncedRedirectArray = items;
            }
          },
          (error) => {
            console.log(error);
          },
        );

        const productSEOSubscription = DataStore.observeQuery(
          ProductSEO,
        ).subscribe(
          async (snapshot) => {
            const { isSynced, items } = snapshot;
            if (isSynced && !_.isEqual(items, this.syncedProductSEOArray)) {
              this.syncedProductSEOArray = items;
            }
          },
          (error) => {
            console.log(error);
          },
        );

        const productContentSubscription = DataStore.observeQuery(
          ProductContent,
          // (c) => c.productId("eq", this.productContentProductId)
        ).subscribe((snapshot) => {
          const { isSynced, items } = snapshot;
          if (
            // isSynced &&
            items.length > 0 &&
            !_.isEqual(items, this.syncedProductContentArray)
          ) {
            this.syncedProductContentArray = items;

            if (this.productContentProductId !== "") {
              const newProductContentObj = items.find(
                (content) => content.productId === this.productContentProductId,
              );
              if (newProductContentObj)
                this.getProductContent(newProductContentObj);
            }
          }
        });

        const tagSubscription = DataStore.observeQuery(ProductTag).subscribe(
          async (snapshot) => {
            const { isSynced, items } = snapshot;
            if (isSynced && !_.isEqual(items, this.syncedProductTagArray)) {
              this.syncedProductTagArray = items;
              this.productTagNameArray = items.map((tag) => {
                return tag.name;
              });
            }
          },
          (error) => {
            console.log(error);
          },
        );

        const categorySubscription = DataStore.observeQuery(
          ProductCategory,
        ).subscribe(
          async (snapshot) => {
            const { isSynced, items } = snapshot;
            if (!_.isEqual(items, this.syncedProductCategoryArray)) {
              this.syncedProductCategoryArray = items;
              // this.productCategoryNameArray = items.map((category) => {
              //   return category.name;
              // });
            }

            if (isSynced) {
              this.syncedProductCategories = true;
            } else {
              this.syncedProductCategories = false;
            }
          },
          (error) => {
            console.log(error);
          },
        );

        store.commit("addSubscriptions", [
          { model: "Redirect", sub: redirectSubscription },
          { model: "ProductSEO", sub: productSEOSubscription },
          { model: "ProductContent", sub: productContentSubscription },
          { model: "ProductTag", sub: tagSubscription },
          { model: "ProductCategory", sub: categorySubscription },
        ]);
      } catch (error) {
        console.log(error);
      }
    },

    syncProducts() {
      const productSubscription = DataStore.observeQuery(Product).subscribe(
        async (snapshot) => {
          const { isSynced, items } = snapshot;

          this.unfilteredProductsArray = items;

          if (items?.length > 0 && !this.changingDatastoreConfig) {
            // console.log("Synced products queryProducts");
            await this.queryProducts();
          }

          if (isSynced) {
            this.syncedProducts = true;
          } else {
            this.syncedProducts = false;
          }
        },
        (error) => {
          console.log(error);
        },
      );

      store.commit("addSubscription", {
        model: "Product",
        sub: productSubscription,
      });
    },

    syncProductBundles() {
      const bundleSubscription = DataStore.observeQuery(
        ProductBundle,
      ).subscribe(
        async (snapshot) => {
          const { isSynced, items } = snapshot;
          if (isSynced && !_.isEqual(items, this.syncedProductBundleArray)) {
            this.syncedProductBundleArray = items;
          }
        },
        (error) => {
          console.log(error);
        },
      );

      store.commit("addSubscription", {
        model: "ProductBundle",
        sub: bundleSubscription,
      });
    },
  },

  beforeDestroy() {
    store.commit("removeSubscriptions", [
      "ProductBundle",
      "Redirect",
      "ProductSEO",
      "Product",
      "ProductTag",
      "ProductCategory",
      "ProductContent",
    ]);

    store.commit("removeDatastorePredicates", [
      "ProductBundle",
      "Redirect",
      "ProductSEO",
      "Product",
      "ProductTag",
      "ProductCategory",
      "ProductContent",
    ]);
  },
};
</script>

<style lang="scss">
.productsSearchInputCSS .v-input__slot {
  margin-bottom: 0px !important;
}

.productsSearchInputCSS .v-select__selections {
  min-height: 36px !important;
}

.thumbnailvrow {
  margin-left: -12px;
  margin-right: -12px;
}

/* #productsDataTable .v-data-footer__pagination {
  visibility: hidden;
}
#productsDataTable .v-data-footer__select {
  visibility: hidden;
} */

.t-datetime-picker {
  .v-tabs-slider-wrapper {
    top: 0;
  }
  .v-picker__title {
    height: 90px;
  }
  .v-time-picker-title__time * {
    font-size: 60px;
    height: 60px;
  }
  .v-picker__body {
    height: 290px;
  }
  .v-tabs-items {
    height: 380px;
  }
}

#expPanelContent > * {
  padding: 12px !important;
}

.plannerPanelTopBorder > div:nth-child(2) {
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel:first-child {
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel--active + div {
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel:last-child {
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel--next-active {
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel--active {
  border-radius: 4px !important;
}

.plannerPanelTopBorder .v-expansion-panel--active #expPanelContent {
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}
</style>
